import { message, Tag } from "antd";
import moment from "moment";

import cookie from "react-cookies";

import messages_cs from "../languages/cs.json";
import messages_de from "../languages/de.json";
import messages_en from "../languages/en.json";
import messages_es from "../languages/es.json";
import messages_fr from "../languages/fr.json";
import messages_it from "../languages/it.json";
import messages_ja from "../languages/ja.json";
import messages_nl from "../languages/nl.json";
import messages_pl from "../languages/pl.json";
import messages_zh from "../languages/tw.json";
import messages_sk from "../languages/sk.json";

import { Text } from "recharts";
import pdfCZ from "../pages/ROI/pdfs/cs-CZ.pdf";
import pdfDE from "../pages/ROI/pdfs/de-DE.pdf";
import pdfUS from "../pages/ROI/pdfs/en-US.pdf";
import pdfES from "../pages/ROI/pdfs/es-ES.pdf";
import pdfFR from "../pages/ROI/pdfs/fr-FR.pdf";
import pdfIT from "../pages/ROI/pdfs/it-IT.pdf";
import pdfJP from "../pages/ROI/pdfs/Ja-JP.pdf";
import pdfNL from "../pages/ROI/pdfs/nl-NL.pdf";
import pdfPL from "../pages/ROI/pdfs/pl-PL.pdf";
import pdfBR from "../pages/ROI/pdfs/pt-BR.pdf";
import pdfCN from "../pages/ROI/pdfs/zh-CN.pdf";

import { createTheme } from "@mui/material";
import { toLogout } from "./APIs";

require("moment/locale/fr");
require("moment/locale/it");
require("moment/locale/es");
require("moment/locale/cs");
require("moment/locale/ja");
require("moment/locale/pl");
require("moment/locale/nl");
require("moment/locale/ja");
require("moment/locale/sk");

const messages = {
  fr: messages_fr,
  en: messages_en,
  es: messages_es,
  it: messages_it,
  cs: messages_cs,
  nl: messages_nl,
  de: messages_de,
  pl: messages_pl,
  th: messages_zh,
  ja: messages_ja,
  sk: messages_sk,
};
var language = navigator.language.split(/[-_]/)[0];

export const successMsg = (msg) => {
  message.success({
    content: msg,
    style: {},
  });
};

export const getLanguage = () => {
  language != "fr" &&
    language != "en" &&
    language != "es" &&
    language != "it" &&
    language != "cs" &&
    language != "nl" &&
    language != "de" &&
    language != "pl" &&
    language != "th" &&
    language != "ja" &&
    language != "sk" &&
    (language = "en");

  return language;
};

export const tagRender = (props) => {
  const { label, value, closable, onClose } = props;

  return (
    <Tag
      color={"#EEEEEE"}
      closable={closable}
      onClose={onClose}
      style={{
        marginRight: 3,
        fontFamily: "Gotham",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "20px",
        lineHeight: "20px",

        color: "#000000",
      }}
    >
      {label}
    </Tag>
  );
};

export const parseJwt = () => {
  var token = cookie.load("token");
  if (null == token) {
    return null;
  }
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(""),
  );

  return JSON.parse(jsonPayload);
};

export const getType = (ToolStore) => {
  return ToolStore.user?.type;
};

export const getUsername = (ToolStore) => {
  return ToolStore.user?.email;
};

export const getDayNameAndDay = (date) => {
  var language = getLanguage();
  if (language == "zh") {
    language += "-tw";
  }

  var date = moment(date).locale(language);
  return date.format("dddd Do MMMM Y");
};

export const getFormattedDateAndTime = (date) => {
  var language = getLanguage();
  if (language == "zh") {
    language += "-tw";
  }

  var date = moment(date).locale(language);
  return date.format("LL H:mm");
};

export const getPDF = () => {
  var language = navigator.userLanguage || navigator.language;
  switch (language) {
    case "cs":
      return pdfCZ;
      break;
    case "de":
      return pdfDE;

      break;
    case "es":
      return pdfES;

      break;
    case "en":
      return pdfUS;
      break;
    case "fr":
      return pdfFR;
      break;
    case "it":
      return pdfIT;
      break;
    case "Ja":
      return pdfJP;
      break;
    case "nl":
      return pdfNL;
      break;

    case "pl":
      return pdfPL;
      break;

    case "pt":
      return pdfBR;

      break;
    case "zh-CN":
      return pdfCN;

    default:
      return pdfUS;
      break;
  }
};

export const checkIfIdExists = (id) => {
  //TODO : change en to language when traductions are available
  if (messages[language][id] == null) {
    return false;
  }
  return true;
};

export const getTranslatedValue = (id) => {
  if (checkIfIdExists(id)) {
    return messages[language][id];
  }
  return id;
};

export const dataSuperior = (rule, value, callback) => {
  if (value < 1) {
    callback(getTranslatedValue("dataSuperior"));
    return;
  }
  callback();
};

export const dataSuperior0 = (rule, value, callback) => {
  if (value < 0) {
    callback("");
    return;
  }
  callback();
};

export const getProducts = (res) => {
  var SmileMateFor = res.results
    .filter((a) => a.fieldName == "practiceProfile")[0]
    .value.filter((x) => x.fieldName == "products")[0]
    .value.filter((y) => y.fieldName == "SmileMateFor")[0].value;
  var monitoringFor = res.results
    .filter((a) => a.fieldName == "practiceProfile")[0]
    .value.filter((x) => x.fieldName == "products")[0]
    .value.filter((y) => y.fieldName == "SmileMateFor")[0].value;
  var bracesFor = res.results
    .filter((a) => a.fieldName == "practiceProfile")[0]
    .value.filter((x) => x.fieldName == "products")[0]
    .value.filter((y) => y.fieldName == "bracesFor")[0].value;
  return {
    SmileMateFor: SmileMateFor,
    monitoringFor: monitoringFor,
    bracesFor: bracesFor,
  };
};
export const toDisplaySmileMate = (res) => {
  var indicators = res.indicators;
  var SmileMateFor = res.results
    .filter((a) => a.fieldName == "practiceProfile")[0]
    .value.filter((x) => x.fieldName == "products")[0]
    .value.filter((y) => y.fieldName == "SmileMateFor")[0].value;
  return (
    SmileMateFor &&
    (indicators.increaseLeads ||
      indicators.increaseConversion ||
      indicators.workLess ||
      indicators.noriskTrying)
  );
};

export const toDisplayMonitoring = (res) => {
  var indicators = res.indicators;

  return (
    indicators.dmSaves ||
    indicators.workLessmonitoring ||
    indicators.Increaseprofitability ||
    indicators.introduceRetention ||
    indicators.relapseRate
  );
};

export const toDisplaySummary = (res) => {
  var indicators = res.indicators;

  return indicators.workLesssummary || indicators.annualMargin;
};

export const errorMsg = (msg) => {
  message.error({
    content: msg,
  });
};

export const toUpdateElementInJson = (data, id, value) => {
  data.forEach((element) => {
    if (Array.isArray(element.value) && id != "speciality") {
      element.value.forEach((sub) => {
        if (sub.fieldName == id) {
          sub.value = value;
        }
      });
    } else if (element.fieldName == id) {
      element.value = value;
    }
  });

  return data;
};

export const CustomTooltip = ({
  active,
  payload,
  label,
  index,
  suffix,
  prefix,
  type,
  currency,
}) => {
  if (active && null != payload && null != type && type == "currency") {
    return (
      <div className="roi--graph-tooltip">
        <p className="label">{label}</p>
        <p className="desc">
          {toFormatNumbers(payload[index].value, currency)}
        </p>
      </div>
    );
  }
  if (active && null != payload) {
    label = label.replace("?", "");
    return (
      <div className="roi--graph-tooltip">
        <p className="label">{`${label} `}</p>
        <p className="desc">
          {(prefix ? prefix : "") +
            payload[index].value +
            (suffix ? " " + suffix : "")}
        </p>
        {null != payload[index].payload.value2 && (
          <p className="desc">
            {(prefix ? prefix : "") +
              payload[index].payload.value2 +
              (suffix ? " " + suffix : "")}
          </p>
        )}
        {null != payload[index].payload.value2 && (
          <p className="desc">
            {(prefix ? prefix : "") +
              payload[index].payload.value3 +
              (suffix ? " " + suffix : "")}
          </p>
        )}
      </div>
    );
  }

  return null;
};

export const CustomizedLabelTwo = (props) => {
  const { x, y, width, height, barSize, value, suffix, prefix, data1, index } =
    props;
  return (
    <text
      x={x + width / 2}
      y={y + height / 2}
      fontSize={value == data1[0].value ? "18" : "18"}
      fontFamily="Gotham"
      fontWeight={"800"}
      textAnchor="middle"
      width={30}
      dominantBaseline="middle"
      fill={index == 0 ? "#6A6E80" : index == 1 ? "#FFFFFF" : "#FFFFFF"}
      dy={index == 0 ? 10 : index == data1.length - 1 ? 20 : -1}
    >
      {index == 0
        ? data1[0].secondValue
        : index == data1.length - 1
        ? data1[data1.length - 1].secondValue
        : value}
    </text>
  );
};

export const CustomizedLabel = (props) => {
  const {
    x,
    y,
    width,
    height,
    barSize,
    value,
    suffix,
    prefix,
    data1,
    type,
    currency,
    index,
  } = props;
  if (null != type && type == "currency") {
    return (
      <text
        x={x + width / 2}
        y={y + height / 2}
        dy={-4}
        fontSize={value == data1[0].value ? "20" : "20"}
        fontFamily="Gotham"
        fontWeight={"600"}
        textAnchor="middle"
        dominantBaseline="middle"
        fill={index == 0 ? "#6A6E80" : "#FFFFFF"}
      >
        {toFormatNumbers(value, currency)}
      </text>
    );
  }
  return (
    <text
      x={x + width / 2}
      y={y + height / 2}
      dy={-4}
      fontSize={value == data1[0].value ? "20" : "20"}
      fontFamily="Gotham"
      fontWeight={"600"}
      textAnchor="middle"
      dominantBaseline="middle"
      fill={index == 0 ? "#6A6E80" : "#FFFFFF"}
    >
      {prefix && prefix}
      {value} {suffix && suffix}
    </text>
  );
};

export const CustomizedLabelBars = (props) => {
  const {
    x,
    y,
    width,
    height,
    barSize,
    value,
    suffix,
    prefix,
    data1,
    colors,
    index,
    entry,
    dy,
  } = props;

  var res = 0;
  if (data1[1].value2 + data1[1].value + data1[1].value3 == value) {
    res = data1[1].value3;
  } else if (data1[1].value2 + data1[1].value == value) {
    res = data1[1].value2;
  } else if (value == data1[1].value) {
    res = data1[1].value;
  }

  if (data1[0].value2 + data1[0].value + data1[0].value3 == value) {
    res = data1[0].value3;
  } else if (data1[0].value2 + data1[0].value == value) {
    res = data1[0].value2;
  } else if (value == data1[0].value) {
    res = data1[0].value;
  }
  // if (data1[1].value2 + data1[1].value + data1[1].value3 == value) {
  //   res = data1[1].value3;
  // } else if (data1[1].value2 + data1[1].value == value) {
  //   res = data1[1].value2;
  // } else {
  //   res = data1[1].value;
  // }
  return (
    <text
      x={x + width / 2}
      y={
        value == data1[1].value2 + data1[1].value + data1[1].value3
          ? y + height / 2 - 20
          : y + height / 2
      }
      dy={
        value == data1[1].value2 + data1[1].value + data1[1].value3
          ? 0
          : value == data1[0].value3 + data1[0].value2 + data1[0].value
          ? 20
          : 0
      }
      fontSize="16"
      fontFamily="Gotham"
      fontWeight="600"
      textAnchor="middle"
      dominantBaseline="middle"
      fill={
        value == data1[1].value2 + data1[1].value + data1[1].value3
          ? colors[1]
          : value == data1[0].value ||
            value == data1[0].value2 + data1[0].value ||
            value == data1[0].value3 + data1[0].value2 + data1[0].value
          ? colors[0]
          : colors[2]
      }
    >
      {prefix && prefix}
      {res.toFixed(1)} {suffix && suffix}
    </text>
  );
};
export const CustomizedLabelBarsFirst = (props) => {
  const {
    x,
    y,
    width,
    height,
    barSize,
    value,
    suffix,
    prefix,
    data1,
    colors,
    index,
    entry,
    dy,
  } = props;

  var res = 0;
  if (data1[1].value2 + data1[1].value + data1[1].value3 == value) {
    res = data1[1].value3;
  } else if (data1[1].value2 + data1[1].value == value) {
    res = data1[1].value2;
  } else if (value == data1[1].value) {
    res = data1[1].value;
  }

  if (data1[0].value2 + data1[0].value + data1[0].value3 == value) {
    res = data1[0].value3;
  } else if (data1[0].value2 + data1[0].value == value) {
    res = data1[0].value2;
  } else if (value == data1[0].value) {
    res = data1[0].value;
  }

  return (
    <text
      x={x + width / 2}
      y={
        value == data1[1].value2 + data1[1].value + data1[1].value3
          ? y + height / 2 - 20
          : y + height / 2
      }
      dy={0}
      fontSize="16"
      fontFamily="Gotham"
      fontWeight="600"
      textAnchor="middle"
      dominantBaseline="middle"
      fill={colors[0]}
    >
      {prefix && prefix}
      {res} {suffix && suffix}
    </text>
  );
};

export const CustomizedAxisTick = ({
  x,
  y,
  payload,
  data,
  className2,
  className1,
}) => {
  var className = className2;
  if (data[0].value == payload.value || payload.value.includes("today")) {
    className = className1;
  }
  var first = payload.value.substr(0, payload.value.indexOf("("));
  var second = payload.value.substr(
    payload.value.indexOf("("),
    payload.value.length - 1,
  );

  return (
    <text
      x={x}
      y={y}
      fontFamily="Gotham"
      textAnchor="middle"
      verticalAnchor="start"
      className="roi--custom-axis-tick"
    >
      <tspan className={className} textAnchor="middle" x={x} y={y + 15}>
        {first}
      </tspan>
      <tspan
        className={className + "-today"}
        textAnchor="middle"
        x={x}
        y={y + 15}
        dy="20"
      >
        {second}
      </tspan>
    </text>
  );
};

export const CustomizedAxisTickSummary = ({
  x,
  y,
  payload,
  data,
  className2,
  className1,
}) => {
  var className = className2;
  if (data[0].value == payload.value || payload.value.includes("today")) {
    className = className1;
  }
  var first = payload.value.substr(0, payload.value.indexOf("?"));
  var second = payload.value.substr(
    payload.value.indexOf("?") + 1,
    payload.value.length - 1,
  );

  return (
    <g
    // transform={`translate(${x - x / },10)`}
    >
      <Text
        x={x}
        y={y}
        width={window.innerWidth < 1200 ? 50 : 250}
        className={className}
        fontFamily="Gotham"
        textAnchor="middle"
        verticalAnchor="start"
        allowDataOverflow
        fontSize={10}
      >
        {first}
      </Text>
      <br />
      <Text
        x={x}
        y={window.innerWidth < 1200 ? y + 60 : y + 30}
        width={window.innerWidth < 1200 ? 50 : 150}
        className={className + "-today"}
        fontFamily="Gotham"
        textAnchor="middle"
        verticalAnchor="start"
        allowDataOverflow
        fontSize={10}
      >
        {second}
      </Text>
    </g>
  );
};
export const getMuiTheme = () =>
  createTheme({
    overrides: {
      MUIDataTableBodyCell: {
        root: {
          backgroundColor: "#F5F8FA",
          color: "#54596E",
          fontSize: "20px",
          lineHeight: "20px",
          fontStyle: "normal",
          fontWeight: "normal",
          fontFamily: "Gotham",
          textAlign: "center",
        },
      },
      MuiTableCell: {
        head: {
          color: "#54596E !important",
          fontSize: "20px !important",
          lineHeight: "20px !important",
          fontStyle: "normal !important",
          fontWeight: "600 !important",
          fontFamily: "Gotham",
          textAlign: "center",
        },
      },
      MUIDataTablePagination: {
        root: {
          fontFamily: "Gotham !important",
        },
      },
    },
  });

export const toCalculateResultNewVersion = (data) => {
  const questions = data.results.questions;
  var answers = {};
  questions.forEach((element) => {
    answers[element.fieldName + "A"] = parseFloat(element.alignersValue);
    answers[element.fieldName + "B"] = parseFloat(element.bracesValue);
  });

  /** inputs */
  const inputsh109 = parseFloat(
    data.inputs.claimBraces.monitoringBracesadultsOrAverageLow,
  );
  const inputsh64 =
    parseFloat(data.inputs.monitoring.impliedReductionAverageLow) / 100;
  const inputsh61 =
    parseFloat(data.inputs.monitoring.reductionInNumberOfCheckUpAverageLow) /
    100;
  const inputsf87 = parseFloat(
    data.inputs.monitoring.refinementAppointmentsNumber,
  );

  const inputsf98 = parseFloat(data.inputs.monitoring.finalAppointments);
  const inputsf74 = parseFloat(data.inputs.monitoring.initialAppointments);
  const inputsh70 =
    parseFloat(data.inputs.monitoring.reductionInNumberOfEmergencyAverageLow) /
    100;
  const inputsh82 =
    parseFloat(
      data.inputs.monitoring.checkUpAdjustmentStafftreatmentCoordinatorLow,
    ) / 100;
  const inputsh83 =
    parseFloat(data.inputs.monitoring.checkUpAdjustmentStafffrontDeskLow) / 100;
  const inputsf75 = parseFloat(
    data.inputs.monitoring.initialAppointmentsDoctor,
  );
  const inputsh84 = parseFloat(
    data.inputs.monitoring.checkUpAdjustmentStaffDoctorLow,
  );

  const inputsh153 = parseFloat(data.inputs.dmNotifs.doctorTimeSpent);
  const inputsh154 =
    parseFloat(data.inputs.dmNotifs.doctorPercentageScan) / 100;
  const inputsf88 = parseFloat(
    data.inputs.monitoring.refinementsAppointmentsDoctor,
  );
  const inputsf78 = parseFloat(
    data.inputs.monitoring.initialAppointmentsFrontDesk,
  );
  const inputsf77 = parseFloat(
    data.inputs.monitoring.initialAppointmentsTreatment,
  );
  const inputsf76 = parseFloat(
    data.inputs.monitoring.initialAppointmentsDentalAssistant,
  );
  const inputsh81 =
    parseFloat(
      data.inputs.monitoring.checkUpAdjustmentStaffdentalAssistantLow,
    ) / 100;
  const inputsh101 = 0; //a voir avec asn ipl147

  const inputsf99 = parseFloat(data.inputs.monitoring.finalAppointmentsDoctor);
  const inputsf89 = parseFloat(
    data.inputs.monitoring.refinementsAppointmentsDentalAssistant,
  );
  const inputsf90 = parseFloat(
    data.inputs.monitoring.refinementsAppointmentsTreatment,
  );
  const inputsf91 = parseFloat(
    data.inputs.monitoring.refinementsAppointmentsFrontDesk,
  );
  const inputsh176 = parseFloat(data.inputs.inputPractice.alignersstaffPrepare);
  const inputsh180 = parseFloat(data.inputs.inputPractice.bracesstaffCheckup);
  const inputsh181 = parseFloat(data.inputs.inputPractice.bracesstaffPrepare);
  const inputsh94 =
    parseFloat(data.inputs.monitoring.reductionInPreparedentalAssistantLow) /
    100;
  const inputsh95 = parseFloat(
    data.inputs.monitoring.reductionInPreparetreatmentCoordinatorLow,
  );
  const inputsh96 = parseFloat(
    data.inputs.monitoring.reductionInPreparefrontDeskLow,
  );

  const inputsf100 = parseFloat(
    data.inputs.monitoring.finalAppointmentsDentalAssistant,
  );
  const inputsf101 = parseFloat(
    data.inputs.monitoring.finalAppointmentsTreatment,
  );
  const inputsf102 = parseFloat(
    data.inputs.monitoring.finalAppointmentsFrontDesk,
  );
  const inputsf120 = parseFloat(
    data.inputs.monitoring.initialAppointmentsFrontDesk,
  );
  const inputsf121 = parseFloat(
    data.inputs.claimBraces.initialAppointmentsTreatment,
  );
  const inputsf122 = parseFloat(
    data.inputs.claimBraces.initialAppointmentsDentalAssistant,
  );

  const inputsf142 = parseFloat(data.inputs.claimBraces.removalRetainerFront);

  const inputsf143 = parseFloat(
    data.inputs.claimBraces.removalRetainerTreatment,
  );

  const inputsf144 = parseFloat(data.inputs.claimBraces.removalRetainerDental);
  const inputsh124 = parseFloat(
    data.inputs.claimBraces.reductionInCheckUpFrontLow,
  );
  const inputsh126 = parseFloat(
    data.inputs.claimBraces.reductionInCheckUpDentalLow,
  );
  const inputsh136 = parseFloat(data.inputs.claimBraces.manageDMFrontLow);
  const inputsh137 = parseFloat(data.inputs.claimBraces.manageTreatmentLow);
  const inputsh138 = parseFloat(data.inputs.claimBraces.manageDentalLow);
  const inputsh132 =
    parseFloat(data.inputs.claimBraces.ofWdentalAssistantLow) / 100;
  const inputsh156 = parseFloat(
    data.inputs.dmNotifs.treatmentCoordinatorTimeSpent,
  );
  const inputsh155 = parseFloat(data.inputs.dmNotifs.dentalAssistant);
  const inputsh157 =
    parseFloat(data.inputs.dmNotifs.treatmentCoordinatorPercentageScan) / 100;
  const inputsh158 = parseFloat(data.inputs.dmNotifs.frontDesk);

  const inputsf118 = parseFloat(data.inputs.claimBraces.initialAppointments);
  const inputsf140 = parseFloat(data.inputs.claimBraces.removalRetainer);
  const inputsf119 = parseFloat(
    data.inputs.claimBraces.initialAppointmentsDoctor,
  );
  const inputsf141 = parseFloat(data.inputs.claimBraces.removalRetainerDoctor);

  const inputsh135 = parseFloat(data.inputs.claimBraces.manageDMDoctorLow);
  const inputsh115 =
    parseFloat(
      data.inputs.claimBraces
        .monitoringreductionInNumberOfEmergencyadultsOrAverageLow,
    ) / 100;

  const inputsh127 = parseFloat(
    data.inputs.claimBraces.reductionInCheckUpDocLow,
  );
  /** */
  var result = {
    percentageDmPatient: 86,
    happyPatient: 0,
    potentialEstimation: {
      braces: {
        low: answers["TSQ1B"],
        high: answers["TSQ1B"],
      },
      aligners: {
        low: answers["TSQ1A"],
        high: answers["TSQ1A"],
      },
      additionalRevenu: 0,
    },
    practiceEfficiency: {
      braces: {
        percentage: 37.9,
        nb: 0,
      },
      aligners: {
        percentage: 46.2,
        nb: 0,
      },
    },
    potentialImpact: {
      braces: {
        low: 0,
        high: 0,
      },
      aligners: {
        low: 0,
        high: 0,
      },
      totalPerYear: {
        total: 0,
        braces: 0,
        aligners: 0,
      },
    },
    timeSaved: {
      doctor: {
        practice: 0,
        dm: 0,
        netSaving: 0,
      },
      staff: {
        practice: 0,
        dm: 0,
        netSaving: 0,
      },
      patient: {
        practice: 0,
      },
    },
    revenue: {
      braces: {
        low: 0,
        high: 0,
      },
      aligners: {
        low: 0,
        high: 0,
      },
    },
  };

  //first block validated
  const ipg177 = answers["TSQ4B"];
  const mcg77 = ipg177;
  const ipg28 = answers["TSQ1B"];
  const mcd11 = ipg28;
  const j50 = (mcd11 * mcg77) / 12;
  const j54 = (answers["TSQ1A"] * answers["TSQ4A"]) / 12;

  const e8 = ((j50 + j54) * result.percentageDmPatient) / 100;
  result.happyPatient = Math.round(e8);

  //second block

  //third block validated
  const h16 = (ipg28 * result.practiceEfficiency.braces.percentage) / 100;
  result.practiceEfficiency.braces.nb = h16;

  const ipg23 = answers["TSQ1A"];
  const h17 = (ipg23 * result.practiceEfficiency.aligners.percentage) / 100;
  result.practiceEfficiency.aligners.nb = Math.round(h17);

  //fourth block

  //braces
  const ipg181 = ipg28 !== 0 ? answers["TSQ5B"] : 0;
  const ipg193 = ipg28 !== 0 ? answers["TSQ6B"] : 0;

  const mcg83 = ipg181 + ipg193;
  const ipg186 = inputsf118;
  const ipl186 = ipg186;
  const ipg190 = inputsf140;
  const ipg188 = ipg181 - ipg186 - ipg190;
  const ipl188 = (1 + inputsh109 / 100) * ipg188;

  const ipl190 = ipg190;
  const ipl181 = ipl186 + ipl188 + ipl190;
  const ipl193 = (1 + inputsh115) * ipg193;

  const mci80 = ipg28 !== 0 ? ipl181 : 0;
  const mci82 = ipg28 !== 0 ? ipl193 : 0;

  const mci83 = ipg28 !== 0 ? Math.round(mci80 + mci82) : 0;
  result.potentialImpact.braces.low = mcg83; //validated
  result.potentialImpact.braces.high = mci83; //validated
  //aligners
  const ipg101 = answers["TSQ5A"];
  const mcg22 = ipg23 !== 0 ? ipg101 : 0;
  const ipg121 = answers["TSQ6A"];
  const mcg24 = ipg23 !== 0 ? ipg121 : 0;
  const mcg25 = ipg23 !== 0 ? mcg22 + mcg24 : 0;

  const ipg111 = inputsf74;
  const ipl111 = ipg111;

  const ipg107 = inputsf87;
  const ipl107 = (1 + inputsh64) * ipg107;
  const ipl116 = ipl107;
  const ipg118 = inputsf98;
  const ipg116 = ipg107;
  const ipg113 = ipg101 - ipg111 - ipg118 - ipg116;
  const ipl113 = (1 + inputsh61) * ipg113;
  const ipl118 = ipg118;
  const ipl101 = ipl111 + ipl116 + ipl113 + ipl118;
  const mci22 = ipg23 !== 0 ? ipl101 : 0;
  const mci24 = ipg23 !== 0 ? (1 + inputsh70) * ipg121 : 0;
  const mci25 = ipg23 !== 0 ? Math.round(mci22 + mci24) : 0;
  result.potentialImpact.aligners.low = mcg25;
  result.potentialImpact.aligners.high = mci25; //pb after comma;

  const j49 = ipg28 !== 0 ? ((mcg83 - mci83) / mcg77) * 12 : 0;
  const j51 = ipg28 !== 0 ? j50 * j49 : 0;
  const ipg97 = answers["TSQ4A"];
  const mcg19 = ipg97;
  const j53 = ipg23 !== 0 ? ((mcg25 - mci25) / mcg19) * 12 : 0;
  const j55 = ipg23 !== 0 ? j53 * j54 : 0;
  const j57 = j51 + j55;

  result.potentialImpact.totalPerYear.total = j57;
  result.potentialImpact.totalPerYear.braces = j51; //validated
  result.potentialImpact.totalPerYear.aligners = j55;

  //fifth block
  const ipg136 = answers["TSQ7A"];
  const ipg137 = inputsf88;
  const ipg138 = inputsf99;
  const ipg135 = inputsf75;

  const ipg139 = 0;
  const ipg140 =
    ipg111 * ipg135 +
    ipg113 * ipg136 +
    ipg116 * ipg137 +
    ipg118 * ipg138 +
    ipg139 +
    ipg121 * ipg136;

  const mcg28 = ipg140 / 60;

  const ipl135 = inputsf75;
  const ipl136 = (1 + inputsh84) * answers["TSQ7A"];
  const ipl121 = (1 + inputsh70) * ipg121;
  const ipl137 = ipg137;
  const ipl138 = ipg138;
  const ipl139 = inputsh153;

  const ipl140 =
    ipl111 * ipl135 +
    ipl113 * ipl136 +
    ipl116 * ipl137 +
    ipl118 * ipl138 +
    ipl139 +
    ipl121 * ipl136;

  const mci28 = ipl140 / 60;
  const ipg207 = inputsf119;
  const ipg208 = answers["TSQ7B"];
  const ipg209 = inputsf141;
  const ipg210 = 0;

  const ipg211 =
    ipg186 * ipg207 +
    ipg188 * ipg208 +
    ipg190 * ipg209 +
    ipg210 +
    ipg193 * ipg208;
  const mcg86 = ipg211 / 60;
  const ipl207 = ipg207;

  const ipl208 = (1 + inputsh127) * ipg208;
  const ipl209 = ipg209;
  const ipl210 = inputsh135;

  const ipl211 =
    ipl186 * ipl207 +
    ipl188 * ipl208 +
    ipl190 * ipl209 +
    ipl210 +
    ipl193 * ipl208;
  const mci86 = ipl211 / 60;

  const i91 = mcg77 == 0 ? 0 : ((mcg86 - mci86) / mcg77) * 12 * j50;
  const h91 = mcg19 == 0 ? 0 : ((mcg28 - mci28) / mcg19) * 12 * j54;

  const h92 = j54 * ((inputsh153 * inputsh154) / 60) * 52;
  const i92 = j50 * ((inputsh153 * inputsh154) / 60) * 52;
  const e92 = h92 + i92;
  const e91 = h91 + i91;
  const e93 = e91 - e92;

  const ipg145 = inputsf78 + inputsf77 + inputsf76;
  const ipg146 = answers["TSQ8A"];
  const ipg148 = answers["TSQ9A"];
  const ipg147 = inputsf89 + inputsf90 + inputsf91;
  const ipg149 = inputsf100 + inputsf101 + inputsf102;
  const ipg150 = 0;
  const ipg151 =
    ipg111 * ipg145 +
    ipg113 * ipg146 +
    ipg116 * ipg147 +
    ipg118 * ipg149 +
    ipg150 +
    ipg148 * ipg101 +
    ipg146 * ipg121;

  const mcg30 = ipg151 / 60;
  const mcg29 = mcg30;
  const ipl145 = ipg145;
  const ipl146 = (1 + inputsh81) * ipg146;
  const ipl147 = (1 + inputsh101) * ipg147;
  const ipl149 = ipg149;
  const ipl150 = inputsh158 + inputsh156 + inputsh155;
  const ipl148 = ipg148 * (1 + inputsh94);

  const ipl151 =
    ipl111 * ipl145 +
    ipl113 * ipl146 +
    ipl116 * ipl147 +
    ipl118 * ipl149 +
    ipl150 +
    ipl148 * ipl101 +
    ipl146 * ipl121;

  const mci30 = ipl151 / 60;
  const ipg165 = 0;
  const ipl165 = ipg165;
  const ipg166 = 0;
  const ipl166 = (1 + inputsh83) * ipg166;
  const ipg167 = 0;
  const ipl167 = ipg167;
  const ipg169 = 0;
  const ipl169 = ipg169;
  const ipl170 = inputsh158;
  const ipg168 = 0;
  const ipl168 = (1 + inputsh96) * ipg168;
  const ipl171 =
    ipl111 * ipl165 +
    ipl113 * ipl166 +
    ipl116 * ipl167 +
    ipl118 * ipl169 +
    ipl170 +
    ipl168 * ipl101;

  const ipg10 = 0;
  const ipg155 = 0;
  const ipl155 = ipg155;
  const ipg156 = 0;
  const ipl156 = ipg156 * (1 + inputsh82);
  const ipg157 = 0;
  const ipl157 = ipg157;
  const ipg159 = 0;
  const ipl159 = ipg159;
  const ipl160 = 0;
  const ipg158 = 0;
  const ipl158 = ipg158 * (1 + inputsh95);
  const ipl161 =
    ipl111 * ipl155 +
    ipl113 * ipl156 +
    ipl116 * ipl157 +
    ipl118 * ipl159 +
    ipl160 +
    ipl158 * ipl101;

  const mci31 = (ipl161 / 60) * ipg10;
  const mci32 = (ipl171 / 60) * ipg10;
  const mci29 = mci32 + mci31 + mci30;
  const h95 = mcg19 == 0 ? 0 : ((mcg29 - mci29) / mcg19) * 12 * j54;
  const mcg90 = 0;
  const mcg89 = 0;
  const ipg216 = inputsf120 + inputsf121 + inputsf122;

  const ipg217 = answers["TSQ8B"];
  const ipg218 = answers["TSQ9B"];
  const ipg219 = inputsf142 + inputsf143 + inputsf144;
  const ipg220 = 0;
  const ipg221 =
    ipg186 * ipg216 +
    ipg188 * ipg217 +
    ipg190 * ipg219 +
    ipg220 +
    ipg218 * ipg181 +
    ipg193 * ipg217;

  const mcg88 = ipg221 / 60;
  const mcg87 = mcg90 + mcg89 + mcg88;
  const ipg234 = 0;
  const ipl234 = ipg234;
  const ipg235 = 0;
  const ipl235 = (1 + inputsh124) * ipg235;
  const ipl237 = 0;
  const ipl238 = 0;
  const ipl236 = 0;
  const ipl239 =
    ipl234 * ipl186 +
    ipl188 * ipl235 +
    ipl237 * ipl190 +
    ipl181 * ipl236 +
    ipl238;
  const ipg205 = 0;
  const mci90 = (ipl239 / 60) * ipg205;
  const mci89 = 0;
  const ipl216 = ipg216;
  const ipl217 = (1 + inputsh126) * ipg217;
  const ipl219 = ipg219;
  const ipl220 =
    ipg205 == 0 ? inputsh136 + inputsh137 + inputsh138 : inputsh138;
  const ipl218 = (1 + inputsh132) * ipg218;
  const ipl221 =
    ipl186 * ipl216 +
    ipl188 * ipl217 +
    ipl190 * ipl219 +
    ipl220 +
    ipl218 * ipl181 +
    ipl193 * ipl217;
  const mci88 = ipl221 / 60;

  const mci87 = mci90 + mci89 + mci88;
  const i95 = mcg77 == 0 ? 0 : ((mcg87 - mci87) / mcg77) * 12 * j50;
  const e95 = h95 + i95;

  const h96 = j54 * ((inputsh156 * inputsh157) / 60) * 52;
  const i96 = j50 * ((inputsh156 * inputsh157) / 60) * 52;
  const e96 = h96 + i96;
  const e97 = e95 - e96;

  const h99 = ipg23 !== 0 ? ((ipg136 + ipg146) * (mcg25 - mci25)) / 60 : 0;
  const i99 = ipg28 !== 0 ? ((ipg208 + ipg217) * (mcg83 - mci83)) / 60 : 0;
  const e99 = calculateValue(h99, i99);

  result.timeSaved = {
    doctor: {
      practice: e91,
      dm: e92,
      netSaving: e93,
    },
    staff: {
      practice: e95,
      dm: e96,
      netSaving: e97,
    },
    patient: {
      practice: e99,
    },
  };

  const ipg41 = answers["TSQ2B"];
  const mcg99 = ipg28 !== 0 ? ipg41 / mcg83 : 0;
  const h116 = mcg99;

  const mci99 = ipg28 !== 0 ? ipg41 / mci83 : 0;
  const j116 = mci99;

  const ipg33 = answers["TSQ2A"];
  const mcg41 = ipg23 !== 0 ? ipg33 / mcg25 : 0;
  const h141 = mcg41;

  const mci41 = ipg23 !== 0 ? ipg33 / mci25 : 0;
  const j141 = mci41;

  result.revenue = {
    braces: {
      low: h116,
      high: j116,
    },
    aligners: {
      low: h141,
      high: j141,
    },
  };

  return result;
};

function calculateValue(H99, I99) {
  // Check for error-like values (e.g., undefined, null, NaN)
  if (
    H99 === null ||
    I99 === null ||
    H99 === undefined ||
    I99 === undefined ||
    isNaN(H99) ||
    isNaN(I99)
  ) {
    return "";
  }

  // If H99 is not a number or 0
  if (typeof H99 !== "number" || H99 === 0) {
    if (typeof I99 !== "number" || I99 === 0) {
      return "";
    } else {
      return I99;
    }
  }

  // If I99 is not a number or 0
  if (typeof I99 !== "number" || I99 === 0) {
    return H99;
  }

  // Default case: average of both
  return (H99 + I99) / 2;
}

export const toCalculateResult = (data, state) => {
  var newPatientStart = data.results
    .filter((a) => a.fieldName == "numberOfCases")[0]
    .value.filter((b) => b.fieldName == "general")[0]
    .value.filter((c) => c.fieldName == "newPatientOneYear")[0].value;
  var avgTreatment = data.results
    .filter((a) => a.fieldName == "numberOfCases")[0]
    .value.filter((b) => b.fieldName == "general")[0]
    .value.filter((c) => c.fieldName == "avgTreatment")[0].value;

  var leadFirstConsult = data.results
    .filter((a) => a.fieldName == "numberOfCases")[0]
    .value.filter((b) => b.fieldName == "cost")[0]
    .value.filter((c) => c.fieldName == "leadToFirstConsult")[0].value;

  var caseAcceptanceRate = data.results
    .filter((a) => a.fieldName == "numberOfCases")[0]
    .value.filter((b) => b.fieldName == "cost")[0]
    .value.filter((c) => c.fieldName == "caseAcceptanceRate")[0].value;
  var newLeadsLowInputs = data.inputs.smileMateSMVC.newLeadLow;
  var newLeadsHighInputs = data.inputs.smileMateSMVC.newLeadHigh;
  var dental =
    newPatientStart /
    ((((1 * leadFirstConsult) / 100) * caseAcceptanceRate) / 100);

  var low = dental * (1 + newLeadsLowInputs / 100);
  var high = dental * (1 + newLeadsHighInputs / 100);

  var newLeadsLowInputs = data.inputs.smileMateSMVC.newLeadLow;
  var newLeadsHighInputs = data.inputs.smileMateSMVC.newLeadHigh;
  var x =
    parseFloat(leadFirstConsult) +
    parseFloat(data.inputs.smileMateSMVC.increaseConversionLow);

  var a = x > 90 ? 90 : x;
  var firstLow = a > leadFirstConsult ? a : leadFirstConsult;

  x =
    parseFloat(leadFirstConsult) +
    parseFloat(data.inputs.smileMateSMVC.increaseConversionHigh);
  a = x > 90 ? 90 : x;

  var firstHigh = a > leadFirstConsult ? a : leadFirstConsult;

  x =
    parseFloat(caseAcceptanceRate) +
    parseFloat(data.inputs.smileMateSMVC.increaseConversionAppLow);
  a = x > 90 ? 90 : x;

  var consultLow = a > caseAcceptanceRate ? a : caseAcceptanceRate;
  x =
    parseFloat(caseAcceptanceRate) +
    parseFloat(data.inputs.smileMateSMVC.increaseConversionAppHigh);
  a = x > 90 ? 90 : x;
  var consultHigh = a > caseAcceptanceRate ? a : caseAcceptanceRate;

  var overallToday = (1 * leadFirstConsult * caseAcceptanceRate) / 100;
  var overallLow = (1 * firstLow * consultLow) / 100;
  var overallHigh = (1 * firstHigh * consultHigh) / 100;

  var impliedToday = (dental * overallToday) / 100;
  var impliedLow = (low * overallLow) / 100;
  var impliedHigh = (high * overallHigh) / 100;

  var productionToday = impliedToday * avgTreatment;
  var productionLow = impliedLow * avgTreatment;
  var productionHigh = impliedHigh * avgTreatment;

  var newTreatmentCasesPerYear =
    (data.inputs.pricing.priceMonthDoctorSmileMate * 12) / avgTreatment;

  var percentageAnnual = (newTreatmentCasesPerYear / newPatientStart) * 100;

  var doctorTimeToday = parseFloat(
    data.results
      .filter((a) => a.fieldName == "timeSpentOnTheExam")[0]
      .value.filter((b) => b.fieldName == "doctorTimeSpent")[0].value,
  );

  var doctorTimeLow =
    doctorTimeToday *
    (1 + parseFloat(data.inputs.smileMateSMVC.reductionDoctorLow / 100));
  var doctorTimeHigh =
    doctorTimeToday *
    (1 + parseFloat(data.inputs.smileMateSMVC.reductionDoctorHigh / 100));

  var dentalAssistantToday = parseFloat(
    data.results
      .filter((a) => a.fieldName == "timeSpentOnTheExam")[0]
      .value.filter((b) => b.fieldName == "staffTimeSpent")[0]
      .value.filter((c) => c.fieldName == "dentalAssistant")[0].value,
  );

  var dentalAssistantLow = parseFloat(
    dentalAssistantToday *
      (1 + parseFloat(data.inputs.smileMateSMVC.reductionStaffDentalLow / 100)),
  );

  var dentalAssistantHigh = parseFloat(
    dentalAssistantToday *
      (1 +
        parseFloat(data.inputs.smileMateSMVC.reductionStaffDentalHigh / 100)),
  );

  var treatmentCoordinatorToday =
    parseFloat(
      data.results
        .filter((a) => a.fieldName == "timeSpentOnTheExam")[0]
        .value.filter((b) => b.fieldName == "staffTimeSpent")[0]
        .value.filter((c) => c.fieldName == "treatmentCoordinator")[0].value,
    ) || 0;
  var treatmentCoordinatorLow = parseFloat(
    treatmentCoordinatorToday *
      (1 +
        parseFloat(data.inputs.smileMateSMVC.reductionStaffTreatmentLow / 100)),
  );
  var treatmentCoordinatorHigh =
    treatmentCoordinatorToday *
    (1 +
      parseFloat(data.inputs.smileMateSMVC.reductionStaffTreatmentHigh / 100));

  var frontDeskToday =
    parseFloat(
      data.results
        .filter((a) => a.fieldName == "timeSpentOnTheExam")[0]
        .value.filter((b) => b.fieldName == "staffTimeSpent")[0]
        .value.filter((c) => c.fieldName == "frontDesk")[0].value,
    ) || 0;
  var frontDeskLow =
    frontDeskToday *
    (1 + parseFloat(data.inputs.smileMateSMVC.reductionStaffFrontLow / 100));
  var frontDeskHigh =
    frontDeskToday *
    (1 + parseFloat(data.inputs.smileMateSMVC.reductionStaffFrontHigh / 100));

  var staffTimeSpentToday =
    parseFloat(dentalAssistantToday) +
    parseFloat(treatmentCoordinatorToday) +
    parseFloat(frontDeskToday);
  var staffTimeSpentLow =
    dentalAssistantLow + treatmentCoordinatorLow + frontDeskLow;
  var staffTimeHigh =
    dentalAssistantHigh + treatmentCoordinatorHigh + frontDeskHigh;

  var averagePracticeToday =
    doctorTimeToday +
    dentalAssistantToday +
    treatmentCoordinatorToday +
    frontDeskToday;
  var averagePracticeLow =
    doctorTimeLow + dentalAssistantLow + treatmentCoordinatorLow + frontDeskLow;
  var averagePracticeHigh =
    doctorTimeHigh +
    dentalAssistantHigh +
    treatmentCoordinatorHigh +
    frontDeskHigh;
  var firstConsultToday = caseAcceptanceRate;

  x =
    parseFloat(caseAcceptanceRate) +
    parseFloat(data.inputs.smileMateSMVC.increaseConversionAppLow);
  a = x > 90 ? 90 : x;

  var firstConsultLow = a > caseAcceptanceRate ? a : caseAcceptanceRate;

  x =
    parseFloat(caseAcceptanceRate) +
    parseFloat(data.inputs.smileMateSMVC.increaseConversionAppHigh);
  a = x > 90 ? 90 : x;
  var firstConsultHigh = a > caseAcceptanceRate ? a : caseAcceptanceRate;

  var impliedFirstAppointmentToday =
    newPatientStart / (firstConsultToday / 100);
  var impliedFirstAppointmentLow = newPatientStart / (firstConsultLow / 100);
  var impliedFirstAppointmentHigh = newPatientStart / (firstConsultHigh / 100);

  var practiceTimeSpentToday =
    (averagePracticeToday * impliedFirstAppointmentToday) / 60;
  var practiceTimeSpentLow =
    (averagePracticeLow * impliedFirstAppointmentLow) / 60;

  var practiceTimeSpentHigh =
    (averagePracticeHigh * impliedFirstAppointmentHigh) / 60;
  var timeReductionLow = practiceTimeSpentLow - practiceTimeSpentToday;
  var timeReductionHigh = practiceTimeSpentHigh - practiceTimeSpentToday;

  var impliedSalaryToday =
    parseFloat(
      (dentalAssistantToday / 60) *
        parseFloat(
          data.results
            .filter((a) => a.fieldName == "numberOfCases")[0]
            .value.filter((b) => b.fieldName == "cost")[0]
            .value.filter((c) => c.fieldName == "stafCostHour")[0]
            .value.filter((d) => d.fieldName == "dentalAssistant")[0].value,
        ) || 0,
    ) +
    parseFloat(
      (treatmentCoordinatorToday / 60) *
        parseFloat(
          data.results
            .filter((a) => a.fieldName == "numberOfCases")[0]
            .value.filter((b) => b.fieldName == "cost")[0]
            .value.filter((c) => c.fieldName == "stafCostHour")[0]
            .value.filter((d) => d.fieldName == "treatmentCoordinator")[0]
            .value,
        ) || 0,
    ) +
    parseFloat(
      (frontDeskToday / 60) *
        parseFloat(
          data.results
            .filter((a) => a.fieldName == "numberOfCases")[0]
            .value.filter((b) => b.fieldName == "cost")[0]
            .value.filter((c) => c.fieldName == "stafCostHour")[0]
            .value.filter((d) => d.fieldName == "frontDesk")[0].value,
        ) || 0,
    );

  var impliedSalaryLow =
    parseFloat(
      (dentalAssistantLow / 60) *
        parseFloat(
          data.results
            .filter((a) => a.fieldName == "numberOfCases")[0]
            .value.filter((b) => b.fieldName == "cost")[0]
            .value.filter((c) => c.fieldName == "stafCostHour")[0]
            .value.filter((d) => d.fieldName == "dentalAssistant")[0].value,
        ) || 0,
    ) +
    parseFloat(
      (treatmentCoordinatorLow / 60) *
        parseFloat(
          data.results
            .filter((a) => a.fieldName == "numberOfCases")[0]
            .value.filter((b) => b.fieldName == "cost")[0]
            .value.filter((c) => c.fieldName == "stafCostHour")[0]
            .value.filter((d) => d.fieldName == "treatmentCoordinator")[0]
            .value,
        ) || 0,
    ) +
    parseFloat(
      (frontDeskLow / 60) *
        parseFloat(
          data.results
            .filter((a) => a.fieldName == "numberOfCases")[0]
            .value.filter((b) => b.fieldName == "cost")[0]
            .value.filter((c) => c.fieldName == "stafCostHour")[0]
            .value.filter((d) => d.fieldName == "frontDesk")[0].value,
        ) || 0,
    );
  var impliedSalaryHigh =
    parseFloat(
      (dentalAssistantHigh / 60) *
        parseFloat(
          data.results
            .filter((a) => a.fieldName == "numberOfCases")[0]
            .value.filter((b) => b.fieldName == "cost")[0]
            .value.filter((c) => c.fieldName == "stafCostHour")[0]
            .value.filter((d) => d.fieldName == "dentalAssistant")[0].value,
        ) || 0,
    ) +
    parseFloat(
      (treatmentCoordinatorHigh / 60) *
        parseFloat(
          data.results
            .filter((a) => a.fieldName == "numberOfCases")[0]
            .value.filter((b) => b.fieldName == "cost")[0]
            .value.filter((c) => c.fieldName == "stafCostHour")[0]
            .value.filter((d) => d.fieldName == "treatmentCoordinator")[0]
            .value,
        ) || 0,
    ) +
    parseFloat(
      (frontDeskHigh / 60) *
        parseFloat(
          data.results
            .filter((a) => a.fieldName == "numberOfCases")[0]
            .value.filter((b) => b.fieldName == "cost")[0]
            .value.filter((c) => c.fieldName == "stafCostHour")[0]
            .value.filter((d) => d.fieldName == "frontDesk")[0].value,
        ) || 0,
    );

  var impliedDoctorCostToday =
    (doctorTimeToday / 60) *
      parseFloat(
        data.results
          .filter((a) => a.fieldName == "numberOfCases")[0]
          .value.filter((b) => b.fieldName == "cost")[0]
          .value.filter((c) => c.fieldName == "doctorCostHour")[0].value,
      ) || 0;
  var impliedDoctorCostLow =
    (doctorTimeLow / 60) *
      parseFloat(
        data.results
          .filter((a) => a.fieldName == "numberOfCases")[0]
          .value.filter((b) => b.fieldName == "cost")[0]
          .value.filter((c) => c.fieldName == "doctorCostHour")[0].value,
      ) || 0;
  var impliedDoctorCostHigh =
    (doctorTimeHigh / 60) *
      parseFloat(
        data.results
          .filter((a) => a.fieldName == "numberOfCases")[0]
          .value.filter((b) => b.fieldName == "cost")[0]
          .value.filter((c) => c.fieldName == "doctorCostHour")[0].value,
      ) || 0;

  var impliedCostFirstToday = impliedFirstAppointmentToday * impliedSalaryToday;
  var impliedCostFirstLow = impliedFirstAppointmentLow * impliedSalaryLow;
  var impliedCostFirstHigh = impliedFirstAppointmentHigh * impliedSalaryHigh;

  var impliedCostSecondToday =
    impliedFirstAppointmentToday * impliedDoctorCostToday;
  var impliedCostSecondLow = impliedFirstAppointmentLow * impliedDoctorCostLow;
  var impliedCostSecondHigh =
    impliedFirstAppointmentHigh * impliedDoctorCostHigh;

  var impliedStaffSavingLow =
    data.results
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((a) => a.fieldName == "showHourly")[0].value == false
      ? 0
      : impliedCostFirstLow - impliedCostFirstToday;
  var impliedStaffSavingHigh =
    data.results
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((a) => a.fieldName == "showHourly")[0].value == false
      ? 0
      : impliedCostFirstHigh - impliedCostFirstToday;

  var impliedDoctorSavingLow =
    data.results
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((a) => a.fieldName == "showHourly")[0].value == false
      ? 0
      : impliedCostSecondLow - impliedCostSecondToday;
  var impliedDoctorSavingHigh =
    data.results
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((a) => a.fieldName == "showHourly")[0].value == false
      ? 0
      : impliedCostSecondHigh - impliedCostSecondToday;

  var practiceEstimatedLow =
    data.results
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((a) => a.fieldName == "showHourly")[0].value == false
      ? 0
      : impliedDoctorSavingLow + impliedStaffSavingLow;
  var practiceEstimatedHigh =
    data.results
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((a) => a.fieldName == "showHourly")[0].value == false
      ? 0
      : impliedStaffSavingHigh + impliedDoctorSavingHigh;

  try {
    return {
      smilemate: {
        impactLeads: {
          low: Math.round(low),
          high: Math.round(high),
          dental: Math.round(dental),
        },
        impactConversion: {
          leadToday: Math.round(dental),
          leadLow: Math.round(low),
          leadHigh: Math.round(high),
          firstToday: Math.round(leadFirstConsult),
          firstLow: Math.round(firstLow),
          firstHigh: Math.round(firstHigh),
          consultToday: Math.round(caseAcceptanceRate),
          consultLow: Math.round(consultLow),
          consultHigh: Math.round(consultHigh),
          overallToday: Math.round(overallToday),
          overallLow: Math.round(overallLow),
          overallHigh: Math.round(overallHigh),
          impliedToday: Math.round(impliedToday),
          impliedLow: Math.round(impliedLow),
          impliedHigh: Math.round(impliedHigh),
          productionToday: Math.round(productionToday),
          productionLow: Math.round(productionLow),
          productionHigh: Math.round(productionHigh),
        },
        lowRisk: {
          newTreatmentCasesPerYear: roundToOne(newTreatmentCasesPerYear),
          percentageAnnual: roundToOne(percentageAnnual),
        },
        impactOnPractice: {
          newTreatmentToday: newPatientStart,
          newTreatmentLow: newPatientStart,
          newTreatmentHigh: newPatientStart,
          averagePracticeToday: averagePracticeToday,
          averagePracticeLow: averagePracticeLow,
          averagePracticeHigh: averagePracticeHigh,
          doctorTimeToday: Math.round(doctorTimeToday),
          doctorTimeLow: Math.round(doctorTimeLow),
          doctorTimeHigh: Math.round(doctorTimeHigh),
          staffTimeToday: Math.round(staffTimeSpentToday),
          staffTimeLow: Math.round(staffTimeSpentLow),
          staffTimeHigh: Math.round(staffTimeHigh),
          dentalAssistantToday: Math.round(dentalAssistantToday),
          dentalAssistantLow: Math.round(dentalAssistantLow),
          dentalAssistantHigh: Math.round(dentalAssistantHigh),
          treatmentCoordinatorToday: Math.round(treatmentCoordinatorToday),
          treatmentCoordinatorLow: Math.round(treatmentCoordinatorLow),
          treatmentCoordinatorHigh: Math.round(treatmentCoordinatorHigh),
          frontDeskToday: Math.round(frontDeskToday),
          frontDeskLow: Math.round(frontDeskLow),
          frontDeskHigh: Math.round(frontDeskHigh),
          firstConsultToday: Math.round(firstConsultToday),
          firstConsultLow: Math.round(firstConsultLow),
          firstConsultHigh: Math.round(firstConsultHigh),
          impliedFirstAppointmentToday: Math.round(
            impliedFirstAppointmentToday,
          ),
          impliedFirstAppointmentLow: Math.round(impliedFirstAppointmentLow),
          impliedFirstAppointmentHigh: Math.round(impliedFirstAppointmentHigh),
          practiceTimeSpentToday: Math.round(practiceTimeSpentToday),
          practiceTimeSpentLow: Math.round(practiceTimeSpentLow),
          practiceTimeSpentHigh: Math.round(practiceTimeSpentHigh),
          timeReductionLow: Math.round(timeReductionLow),
          timeReductionHigh: Math.round(timeReductionHigh),
          impliedSalaryToday: Math.round(impliedSalaryToday),
          impliedSalaryLow: Math.round(impliedSalaryLow),
          impliedSalaryHigh: Math.round(impliedSalaryHigh),
          impliedDoctorCostToday: Math.round(impliedDoctorCostToday),
          impliedDoctorCostLow: Math.round(impliedDoctorCostLow),
          impliedDoctorCostHigh: Math.round(impliedDoctorCostHigh),
          impliedCostFirstToday: Math.round(impliedCostFirstToday),
          impliedCostFirstLow: Math.round(impliedCostFirstLow),
          impliedCostFirstHigh: Math.round(impliedCostFirstHigh),
          impliedCostSecondToday: Math.round(impliedCostSecondToday),
          impliedCostSecondLow: Math.round(impliedCostSecondLow),
          impliedCostSecondHigh: Math.round(impliedCostSecondHigh),
          impliedStaffSavingLow: Math.round(impliedStaffSavingLow),
          impliedStaffSavingHigh: Math.round(impliedStaffSavingHigh),
          impliedDoctorSavingLow: Math.round(impliedDoctorSavingLow),
          impliedDoctorSavingHigh: Math.round(impliedDoctorSavingHigh),

          practiceEstimatedLow: Math.round(practiceEstimatedLow),
          practiceEstimatedHigh: Math.round(practiceEstimatedHigh),
        },
      },

      monitoring: getMonitring(data, state),
    };
  } catch (error) {
    console.log(error);
  }
};

export const getMonitring = (data, state) => {
  var r20 = 0;
  var r21 = 0;

  var r24 = 0;
  var r25 = 0;
  var r28 = 0;
  var r29 = 0;

  var r33 = 0;
  var r34 = 0;
  var r37 = 0;
  var r38 = 0;

  var r41 = 0;
  var r42 = 0;
  var r45 = 0;
  var r46 = 0;
  var r53 = 0;
  var r54 = 0;
  var r61 = 0;
  var r62 = 0;
  var r63 = 0;
  var r64 = 0;
  var r65 = 0;
  var r66 = 0;
  var r67 = 0;
  var r72 = 0;
  var r73 = 0;
  var r77 = 0;
  var r78 = 0;
  var r83 = 0;
  var r85 = 0;
  var r86 = 0;
  var r87 = 0;

  var r97 = 0;
  var r98 = 0;
  var r101 = 0;
  var r102 = 0;
  var r107 = 0;
  var r108 = 0;
  var r121 = 0;
  var r122 = 0;
  var r127 = 0;
  var r128 = 0;
  var r136 = 0;
  var r145 = 0;
  var r147 = 0;
  var r155 = 0;
  var r157 = 0;
  var r165 = 0;
  var r167 = 0;
  var r176 = 0;
  var r177 = 0;
  var r180 = 0;
  var r181 = 0;
  var r192 = 0;
  var r193 = 0;
  var r198 = 0;
  var r199 = 0;
  var r208 = 0;
  var r216 = 0;
  var r217 = 0;
  var r225 = 0;
  var r226 = 0;
  var r234 = 0;
  var r235 = 0;
  var r251 = 0;
  var r252 = 0;
  var r253 = 0;
  var r257 = 0;
  var r258 = 0;
  var r259 = 0;
  var r262 = 0;

  var r99 = 0;
  var r119 = 0;
  var r118 = 0;
  var r110 = 0;
  var r178 = 0;
  var r104 = 0;
  var r189 = 0;
  var r190 = 0;
  /** 1ere colonne */
  data.results
    .filter((x) => x.fieldName == "numberOfCases")[0]
    .value.filter((e) => e.fieldName == "general")[0]
    .value.filter((x) => {
      if (x.fieldName == "newPatientOneYear") {
        r20 = parseFloat(x.value);
      }
      if (x.fieldName == "avgTreatment") {
        r21 = parseFloat(x.value);
      }
      if (x.fieldName == "newAlignersTreatement") {
        r24 = parseFloat(x.value[0].value);
        r25 = parseFloat(x.value[1].value);
      }
      if (x.fieldName == "newBraces") {
        r28 = parseFloat(x.value[0].value);
        r29 = parseFloat(x.value[1].value);
      }
    });

  data.results
    .filter((x) => x.fieldName == "numberOfCases")[0]
    .value.filter((e) => e.fieldName == "alignersCases")[0]
    .value.filter((x) => {
      if (x.fieldName == "averagePrice") {
        r33 = parseFloat(x.value[0].value);
        r34 = parseFloat(x.value[1].value);
      }
      if (x.fieldName == "addFeeAligners") {
        r37 = parseFloat(x.value[0].value);
        r38 = parseFloat(x.value[1].value);
      }
    });

  data.results
    .filter((x) => x.fieldName == "numberOfCases")[0]
    .value.filter((e) => e.fieldName == "bracesCases")[0]
    .value.filter((x) => {
      if (x.fieldName == "averagePriceBraces") {
        r41 = parseFloat(x.value[0].value);
        r42 = parseFloat(x.value[1].value);
      }
      if (x.fieldName == "addFeeBraces") {
        r45 = parseFloat(x.value[0].value);
        r46 = parseFloat(x.value[1].value);
      }
    });

  data.results
    .filter((x) => x.fieldName == "numberOfCases")[0]
    .value.filter((e) => e.fieldName == "preTreatment")[0]
    .value.filter((x) => {
      if (x.fieldName == "teensYear") {
        r53 = parseFloat(x.value);
      }
      if (x.fieldName == "whoAre") {
        r54 = parseFloat(x.value);
      }
    });

  data.results
    .filter((x) => x.fieldName == "numberOfCases")[0]
    .value.filter((e) => e.fieldName == "cost")[0]
    .value.filter((x) => {
      if (x.fieldName == "averageSpend") {
        r61 = parseFloat(x.value);
      }
      if (x.fieldName == "ppe") {
        r62 = parseFloat(x.value);
      }
      if (x.fieldName == "stafCostHour") {
        r64 = parseFloat(x.value[0].value);
        r65 = parseFloat(x.value[1].value);
        r66 = parseFloat(x.value[2].value);
      }
      if (x.fieldName == "doctorCostHour") {
        r67 = parseFloat(x.value);
      }
      if (x.fieldName == "leadToFirstConsult") {
        r72 = parseFloat(x.value);
      }
      if (x.fieldName == "caseAcceptanceRate") {
        r73 = parseFloat(x.value);
      }
    });

  r77 = data.results.filter((x) => x.fieldName == "conversionStatistics")[0]
    .value[0].value;
  r78 = data.results.filter((x) => x.fieldName == "conversionStatistics")[0]
    .value[1].value;

  data.results
    .filter((x) => x.fieldName == "timeSpentOnTheExam")[0]
    .value.filter((x) => {
      if (x.fieldName == "doctorTimeSpent") {
        r83 = parseFloat(x.value);
      }

      if (x.fieldName == "staffTimeSpent") {
        r85 = parseFloat(x.value[0].value);
        r86 = parseFloat(x.value[1].value);
        r87 = parseFloat(x.value[2].value);
      }
    });

  try {
    r262 =
      parseFloat(
        data.results.filter((x) => x.fieldName == "goalsAndObjectives")[0]
          .value[0].value,
      ) || 0;
  } catch (error) {}

  data.results
    .filter((x) => x.fieldName == "workflowTreatment")[0]
    .value.filter((x) => {
      if (x.fieldName == "alignersStatistics") {
        x.value.forEach((z) => {
          if (z.fieldName == "averageDuration") {
            r97 = parseFloat(z.value[0].value) || 0;
            r98 = parseFloat(z.value[1].value) || 0;
          }
          if (z.fieldName == "appointmentsOverTreatment") {
            r101 = parseFloat(z.value[0].value) || 0;
            r102 = parseFloat(z.value[1].value) || 0;
          }
          if (z.fieldName == "appointementRefinement") {
            r107 = z.value[0].value;
            r108 = parseFloat(z.value[1].value) || 0;
          }
          if (z.fieldName == "emergencyAppointments") {
            r121 = parseFloat(z.value[0].value) || 0;
            r122 = parseFloat(z.value[1].value) || 0;
          }
        });
      }
      if (x.fieldName == "alignersCost") {
        x.value.forEach((z) => {
          if (z.fieldName == "costAlignersData") {
            r127 = parseFloat(z.value) || 0;
          }
          if (z.fieldName == "consumables") {
            r128 = parseFloat(z.value) || 0;
          }
        });
      }
      if (x.fieldName == "alignersTimeSpent") {
        x.value.forEach((z) => {
          if (z.fieldName == "timeSpentCheckupAppointement") {
            r136 = parseFloat(z.value) || 0;
          }
          if (z.fieldName == "dentalAssistant") {
            r145 = parseFloat(z.value[0].value) || 0;
            r147 = parseFloat(z.value[1].value) || 0;
          }
          if (z.fieldName == "treatmentCoordinator") {
            r155 = parseFloat(z.value[0].value) || 0;
            r157 = parseFloat(z.value[1].value) || 0;
          }
          if (z.fieldName == "frontDesk") {
            r165 = parseFloat(z.value[0].value) || 0;
            r167 = parseFloat(z.value[1].value) || 0;
          }
        });
      }

      if (x.fieldName == "bracesStatistics") {
        x.value.forEach((z) => {
          if (z.fieldName == "bracesAverageDuration") {
            r176 = parseFloat(z.value[0].value);
            r177 = parseFloat(z.value[1].value) || 0;
          }
          if (z.fieldName == "bracesAppointmentsOverTreatment") {
            r180 = parseFloat(z.value[0].value);
            r181 = parseFloat(z.value[1].value) || 0;
          }
          if (z.fieldName == "bracesInaddition") {
            r192 = parseFloat(z.value[0].value);
            r193 = parseFloat(z.value[1].value) || 0;
          }
        });
      }
      if (x.fieldName == "bracesCost") {
        x.value.forEach((z) => {
          if (z.fieldName == "costBracesPractice") {
            r198 = parseFloat(z.value);
          }
          if (z.fieldName == "consumableTreatment") {
            r199 = parseFloat(z.value);
          }
        });
      }
      if (x.fieldName == "bracesTimeSpent") {
        x.value.forEach((z) => {
          if (z.fieldName == "timeSpentCheckupAppointement") {
            r208 = parseFloat(z.value);
          }
          if (z.fieldName == "dentalAssistant") {
            r216 = parseFloat(z.value[0].value) || 0;
            r217 = parseFloat(z.value[1].value) || 0;
          }
          if (z.fieldName == "treatmentCoordinator") {
            r225 = parseFloat(z.value[0].value) || 0;
            r226 = parseFloat(z.value[1].value) || 0;
          }
          if (z.fieldName == "frontDesk") {
            r234 = parseFloat(z.value[0].value) || 0;
            r235 = parseFloat(z.value[1].value) || 0;
          }
        });
      }
      if (x.fieldName == "retention") {
        x.value.forEach((z) => {
          if (z.fieldName == "percentageComingBack") {
            r251 = z.value / 100;
          }
          if (z.fieldName == "averageVistis") {
            r252 = parseFloat(z.value);
          }
          if (z.fieldName == "labFee") {
            r253 = parseFloat(z.value);
          }
        });
      }
      if (x.fieldName == "relapse") {
        x.value.forEach((z) => {
          if (z.fieldName == "averageRelapse") {
            r257 = parseFloat(z.value[1].value) || 0;
            r258 = parseFloat(z.value[0].value) || 0;
          }
        });
      }
    });
  /** inputs */
  var inputsf14 = parseFloat(data.inputs.pricing.scanboxCost);
  var inputsf15 = parseFloat(data.inputs.pricing.cheekRetractors);
  var inputsg18 = parseFloat(data.inputs.pricing.priceMonthDoctorSmileMate);
  var inputsf25 = parseFloat(data.inputs.pricing.nbPatientIncl);

  var inputse28 = parseFloat(data.inputs.pricing.tier1LicenseFee);
  var inputsf28 = parseFloat(data.inputs.pricing.tier1PerPatient);
  var inputsg28 = parseFloat(data.inputs.pricing.tier1Braces);

  var inputse29 = parseFloat(data.inputs.pricing.licenseFee);
  var inputsf29 = parseFloat(data.inputs.pricing.nbPatientIncl);
  var inputsg29 = parseFloat(data.inputs.pricing.bracesInput);

  var inputse30 = parseFloat(data.inputs.pricing.tier2LicenseFee);
  var inputsf30 = parseFloat(data.inputs.pricing.tier2PerPatient);
  var inputsg30 = parseFloat(data.inputs.pricing.tier2Braces);

  var inputse31 = parseFloat(data.inputs.pricing.tier3LicenseFee);
  var inputsf31 = parseFloat(data.inputs.pricing.tier3PerPatient);
  var inputsg31 = parseFloat(data.inputs.pricing.tier3Braces);

  var inputse32 = parseFloat(data.inputs.pricing.tier4LicenseFee);
  var inputsf32 = parseFloat(data.inputs.pricing.tier4PerPatient);
  var inputsg32 = parseFloat(data.inputs.pricing.tier4Braces);

  var inputse33 = parseFloat(data.inputs.pricing.tier5LicenseFee);
  var inputsf33 = parseFloat(data.inputs.pricing.tier5PerPatient);
  var inputsg33 = parseFloat(data.inputs.pricing.tier5Braces);

  var inputsh40 = parseFloat(data.inputs.smileMateSMVC.newLeadLow) / 100;
  var inputsi40 = parseFloat(data.inputs.smileMateSMVC.newLeadHigh) / 100;

  var inputsh41 =
    parseFloat(data.inputs.smileMateSMVC.increaseConversionLow) / 100;
  var inputsi41 =
    parseFloat(data.inputs.smileMateSMVC.increaseConversionHigh) / 100;

  var inputsh42 =
    parseFloat(data.inputs.smileMateSMVC.increaseConversionAppLow) / 100;
  var inputsi42 =
    parseFloat(data.inputs.smileMateSMVC.increaseConversionAppHigh) / 100;

  var inputsh43 =
    parseFloat(data.inputs.smileMateSMVC.reductionDoctorLow) / 100;
  var inputsi43 =
    parseFloat(data.inputs.smileMateSMVC.reductionDoctorHigh) / 100;

  var inputsh44 =
    parseFloat(data.inputs.smileMateSMVC.reductionStaffDentalLow) / 100;
  var inputsi44 =
    parseFloat(data.inputs.smileMateSMVC.reductionStaffDentalHigh) / 100;

  var inputsh45 =
    parseFloat(data.inputs.smileMateSMVC.reductionStaffDentalLow) / 100;
  var inputsi45 =
    parseFloat(data.inputs.smileMateSMVC.reductionStaffDentalHigh) / 100;

  var inputsh46 =
    parseFloat(data.inputs.smileMateSMVC.reductionStaffTreatmentLow) / 100;
  var inputsi46 =
    parseFloat(data.inputs.smileMateSMVC.reductionStaffTreatmentHigh) / 100;

  var inputsh47 =
    parseFloat(data.inputs.smileMateSMVC.reductionStaffFrontLow) / 100;
  var inputsi47 =
    parseFloat(data.inputs.smileMateSMVC.reductionStaffFrontHigh) / 100;

  var inputsf49 = parseFloat(data.inputs.smileMateSMVC.grossMarginToday) / 100;

  var inputsf50 = parseFloat(data.inputs.smileMateSMVC.labourToday) / 100;

  var inputsh61 =
    parseFloat(data.inputs.monitoring.reductionInNumberOfCheckUpAverageLow) /
    100;
  var inputsi61 =
    parseFloat(data.inputs.monitoring.reductionInNumberOfCheckUpAverageHigh) /
    100;

  var inputsh62 =
    parseFloat(data.inputs.monitoring.reductionInNumberOfCheckUpTeensLow) / 100;
  var inputsi62 =
    parseFloat(data.inputs.monitoring.reductionInNumberOfCheckUpTeensHigh) /
    100;

  var inputsh64 =
    parseFloat(data.inputs.monitoring.impliedReductionAverageLow) / 100;
  var inputsi64 =
    parseFloat(data.inputs.monitoring.impliedReductionAverageHigh) / 100;

  var inputsh65 =
    parseFloat(data.inputs.monitoring.impliedReductionTeensLow) / 100;
  var inputsi65 =
    parseFloat(data.inputs.monitoring.impliedReductionTeensHigh) / 100;

  var inputsh70 =
    parseFloat(data.inputs.monitoring.reductionInNumberOfEmergencyAverageLow) /
    100;
  var inputsi70 =
    parseFloat(data.inputs.monitoring.reductionInNumberOfEmergencyAverageHigh) /
    100;

  var inputsh71 =
    parseFloat(data.inputs.monitoring.reductionInNumberOfEmergencyTeensLow) /
    100;
  var inputsi71 =
    parseFloat(data.inputs.monitoring.reductionInNumberOfEmergencyTeensHigh) /
    100;

  var inputsf74 = parseFloat(data.inputs.monitoring.initialAppointments);
  var inputsf75 = parseFloat(data.inputs.monitoring.initialAppointmentsDoctor);
  var inputsf76 = parseFloat(
    data.inputs.monitoring.initialAppointmentsDentalAssistant,
  );
  var inputsf77 = parseFloat(
    data.inputs.monitoring.initialAppointmentsTreatment,
  );
  var inputsf78 = parseFloat(
    data.inputs.monitoring.initialAppointmentsFrontDesk,
  );
  var inputsh81 = parseFloat(
    data.inputs.monitoring.checkUpAdjustmentStaffdentalAssistantLow,
  );
  var inputsi81 = parseFloat(
    data.inputs.monitoring.checkUpAdjustmentStaffdentalAssistantHigh,
  );
  var inputsh82 = parseFloat(
    data.inputs.monitoring.checkUpAdjustmentStafftreatmentCoordinatorLow,
  );
  var inputsi82 = parseFloat(
    data.inputs.monitoring.checkUpAdjustmentStafftreatmentCoordinatorHigh,
  );
  var inputsh83 = parseFloat(
    data.inputs.monitoring.checkUpAdjustmentStafffrontDeskLow,
  );
  var inputsi83 = parseFloat(
    data.inputs.monitoring.checkUpAdjustmentStafffrontDeskhigh,
  );

  var inputsh84 = parseFloat(
    data.inputs.monitoring.checkUpAdjustmentStaffDoctorLow,
  );
  var inputsi84 = parseFloat(
    data.inputs.monitoring.checkUpAdjustmentStaffDoctorHigh,
  );

  var inputsf87 = parseFloat(
    data.inputs.monitoring.refinementsAppointmentsDoctor,
  );
  var inputsf88 = parseFloat(
    data.inputs.monitoring.refinementsAppointmentsDentalAssistant,
  );
  var inputsf89 = parseFloat(
    data.inputs.monitoring.refinementsAppointmentsTreatment,
  );
  var inputsf90 = parseFloat(
    data.inputs.monitoring.refinementsAppointmentsFrontDesk,
  );

  var inputsh93 =
    parseFloat(data.inputs.monitoring.reductionInPreparedentalAssistantLow) /
    100;
  var inputsi93 =
    parseFloat(data.inputs.monitoring.reductionInPreparedentalAssistantHigh) /
    100;
  var inputsh94 =
    parseFloat(
      data.inputs.monitoring.reductionInPreparetreatmentCoordinatorLow,
    ) / 100;
  var inputsf94 =
    parseFloat(
      data.inputs.monitoring.reductionInPreparetreatmentCoordinatorHigh,
    ) / 100;
  var inputsh95 =
    parseFloat(data.inputs.monitoring.reductionInPreparefrontDeskLow) / 100;
  var inputsi95 =
    parseFloat(data.inputs.monitoring.reductionInPreparefrontDeskhigh) / 100;

  var inputsf97 = parseFloat(data.inputs.monitoring.finalAppointments);
  var inputsf98 = parseFloat(data.inputs.monitoring.finalAppointmentsDoctor);
  var inputsf99 = parseFloat(
    data.inputs.monitoring.finalAppointmentsDentalAssistant,
  );

  var inputsh100 = 0; //a voir avec clément;
  var inputsi100 = 0; //a voir avec clément;
  var inputsf100 = parseFloat(
    data.inputs.monitoring.finalAppointmentsTreatment,
  );
  var inputsf101 = parseFloat(
    data.inputs.monitoring.finalAppointmentsFrontDesk,
  );

  var inputsh103 = parseFloat(data.inputs.monitoring.manageDMsDoctorLow);
  var inputsi103 = parseFloat(data.inputs.monitoring.manageDMsDoctorHigh);

  var inputsh104 = parseFloat(
    data.inputs.monitoring.manageDMsDentalAssistantLow,
  );
  var inputsi104 = parseFloat(
    data.inputs.monitoring.manageDMsDentalAssistantHigh,
  );

  var inputsh105 = parseFloat(data.inputs.monitoring.manageDMsTreatmentLow);
  var inputsi105 = parseFloat(data.inputs.monitoring.manageDMsTreatmentHigh);

  var inputsh106 = parseFloat(data.inputs.monitoring.manageDMsFrontDeskLow);
  var inputsi106 = parseFloat(data.inputs.monitoring.manageDMsFrontDeskHigh);

  var inputsi108 = parseFloat(data.inputs.monitoring.treatmentDurationAdults);
  var inputsi109 = parseFloat(data.inputs.monitoring.treatmentDurationTeen);

  //braces
  var inputsh113 =
    parseFloat(data.inputs.claimBraces.monitoringBracesadultsOrAverageLow) /
    100;
  var inputsi113 =
    parseFloat(data.inputs.claimBraces.monitoringBracesadultsOrAverageHigh) /
    100;

  var inputsi114 =
    parseFloat(data.inputs.claimBraces.monitoringBracesteensHigh) / 100;
  var inputsh114 =
    parseFloat(data.inputs.claimBraces.monitoringBracesteensLow) / 100;

  var inputsh119 =
    parseFloat(
      data.inputs.claimBraces
        .monitoringreductionInNumberOfEmergencyadultsOrAverageLow,
    ) / 100;
  var inputsi119 =
    parseFloat(
      data.inputs.claimBraces
        .monitoringreductionInNumberOfEmergencyadultsOrAverageHigh,
    ) / 100;

  var inputsh120 =
    parseFloat(
      data.inputs.claimBraces.monitoringreductionInNumberOfEmergencyteensLow,
    ) / 100;
  var inputsi120 =
    parseFloat(
      data.inputs.claimBraces.monitoringreductionInNumberOfEmergencyteensHigh,
    ) / 100;

  var inputsf122 = parseFloat(data.inputs.claimBraces.initialAppointments);
  var inputsf123 = parseFloat(
    data.inputs.claimBraces.initialAppointmentsDoctor,
  );
  var inputsf124 = parseFloat(data.inputs.claimBraces.initialAppointmentsFront);
  var inputsf125 = parseFloat(
    data.inputs.claimBraces.initialAppointmentsTreatment,
  );
  var inputsf126 = parseFloat(
    data.inputs.claimBraces.initialAppointmentsDentalAssistant,
  );

  var inputsh128 = parseFloat(
    data.inputs.claimBraces.reductionInCheckUpFrontLow,
  );
  var inputsi128 = parseFloat(
    data.inputs.claimBraces.reductionInCheckUpFrontHigh,
  );

  var inputsh129 = parseFloat(
    data.inputs.claimBraces.reductionInCheckUpTreatmentLow,
  );
  var inputsi129 = parseFloat(
    data.inputs.claimBraces.reductionInCheckUpTreatmentHigh,
  );

  var inputsh130 = parseFloat(
    data.inputs.claimBraces.reductionInCheckUpDentalLow,
  );
  var inputsi130 = parseFloat(
    data.inputs.claimBraces.reductionInCheckUpDentalHigh,
  );

  var inputsh131 = parseFloat(data.inputs.claimBraces.reductionInCheckUpDocLow);
  var inputsi131 = parseFloat(
    data.inputs.claimBraces.reductionInCheckUpDocHigh,
  );

  var inputsh134 = parseFloat(data.inputs.claimBraces.ofWFrontLow) / 100;
  var inputsi134 = parseFloat(data.inputs.claimBraces.ofWFrontHigh) / 100;

  var inputsi135 = parseFloat(data.inputs.claimBraces.ofWTreatmentHigh) / 100;

  var inputsh136 =
    parseFloat(data.inputs.claimBraces.ofWdentalAssistantLow) / 100;
  var inputsi136 =
    parseFloat(data.inputs.claimBraces.ofWdentalAssistantHigh) / 100;

  var inputsh139 = parseFloat(data.inputs.claimBraces.manageDMDoctorLow);
  var inputsi139 = parseFloat(data.inputs.claimBraces.manageDMDoctorHigh);

  var inputsh140 = parseFloat(data.inputs.claimBraces.manageDMFrontLow);
  var inputsi140 = parseFloat(data.inputs.claimBraces.manageDMFrontHigh);

  var inputsh141 = parseFloat(data.inputs.claimBraces.manageTreatmentLow);
  var inputsi141 = parseFloat(data.inputs.claimBraces.manageTreatmentHigh);

  var inputsh142 = parseFloat(data.inputs.claimBraces.manageDentalLow);
  var inputsi142 = parseFloat(data.inputs.claimBraces.manageDentalHigh);

  var inputsf144 = parseFloat(data.inputs.claimBraces.removalRetainer);
  var inputsf145 = parseFloat(data.inputs.claimBraces.removalRetainerDoctor);
  var inputsf146 = parseFloat(data.inputs.claimBraces.removalRetainerFront);
  var inputsf147 = parseFloat(data.inputs.claimBraces.removalRetainerTreatment);
  var inputsf148 = parseFloat(data.inputs.claimBraces.removalRetainerDental);

  var inputsi150 = parseFloat(data.inputs.claimBraces.treatmentDurationTeen);
  var inputsi151 = parseFloat(data.inputs.claimBraces.treatmentDurationAdults);
  // var inputsh153 = 0.05;
  // var inputsi153 = 0.1;
  var inputsh153 = (parseFloat(data.inputs.monitoring.increaseLow) || 0) / 100;
  var inputsi153 = (parseFloat(data.inputs.monitoring.increaseHigh) || 0) / 100;
  //growth guidance
  var inputsf154 = parseFloat(data.inputs.growthGuidance.percentageKids) / 100;
  var inputsh155 =
    parseFloat(data.inputs.growthGuidance.percentageIncreaseLow) / 100;
  var inputsi155 =
    parseFloat(data.inputs.growthGuidance.percentageIncreaseHigh) / 100;

  //retention
  var inputsh158 = parseFloat(data.inputs.retention.percentageTakeUpLow) / 100;
  var inputsi158 = parseFloat(data.inputs.retention.percentageTakeUpHigh) / 100;
  var inputsh159 = parseFloat(data.inputs.retention.initialFeeLow);
  var inputsi159 = parseFloat(data.inputs.retention.initialFeeHigh);
  var inputsh160 = parseFloat(data.inputs.retention.cogsLow);
  var inputsi160 = parseFloat(data.inputs.retention.cogsHigh);
  var inputsh161 = parseFloat(data.inputs.retention.relapseLow) / 100;
  var inputsi161 = parseFloat(data.inputs.retention.relapseHigh) / 100;
  var inputsi162 = parseFloat(data.inputs.retention.minRelapse) / 100;

  /** */
  var r55 = (1 - r54 / 100) * r53;
  var t55 = r55;
  var r56 = inputsf154;
  var x = r56 * (1 + inputsh155);
  var t56 = x > 0.95 ? 0.95 : x;

  var u55 = r55;
  var u56 = r56 * (1 + inputsi155) > 0.95 ? 0.95 : r56 * (1 + inputsi155);

  x = r72 / 100 + inputsh41;
  var y = x > 0.9 ? 0.9 : x;
  var t72 = x > y ? x : y;

  x = r72 / 100 + inputsi41;
  y = x > 0.9 ? 0.9 : x;
  var u72 = x > y ? x : y;

  x = r73 / 100 + inputsh42;
  y = x > 0.9 ? 0.9 : x;
  var t73 = x > y ? x : y;

  x = r73 / 100 + inputsi42;
  y = x > 0.9 ? 0.9 : x;
  var u73 = x > y ? x : y;

  x = r77 / 100 + inputsh41;
  var y = x > 0.9 ? 0.9 : x;
  var t77 = x > y ? x : y;

  x = r77 / 100 + inputsi41;
  y = x > 0.9 ? 0.9 : x;
  var u77 = x > y ? x : y;

  x = r78 / 100 + inputsh42;
  y = x > 0.9 ? 0.9 : x;
  var t78 = x > y ? x : y;

  x = r78 / 100 + inputsi42;
  y = x > 0.9 ? 0.9 : x;
  var u78 = x > y ? x : y;

  var t85 = r85 * (1 + inputsh45);
  var u85 = r85 * (1 + inputsi45);

  var t86 = r86 * (1 + inputsh46);
  var u86 = r86 * (1 + inputsi46);

  var t87 = r87 * (1 + inputsh47);
  var u87 = r87 * (1 + inputsi47);

  var u97 = r97 > inputsi108 ? inputsi108 : r97;
  var t97 = (u97 + parseFloat(r97)) / 2;

  var u98 = r98 > inputsi109 ? inputsi109 : r98;
  var t98 = (u98 + parseFloat(r98)) / 2;

  var r111 = inputsf74;

  var t111 = r111;
  var t107 = (1 + inputsh64) * r107;
  var t116 = t107;

  var r113 = 0;
  var r116 = Math.round(r107);

  r118 = inputsf97;

  if (r101 != 0) {
    r113 = r101 - r111 - r118 - r116;
  }
  var t113 = r113 * (1 + inputsh61);

  var t118 = r118;

  var t101 = t111 + t116 + t113 + t118;

  var t108 = (1 + inputsh65) * r108;
  var t117 = t108;
  var r114 = 0;
  var r117 = r108;

  if (r102 != 0) {
    r114 = r102 - r111 - r118 - r117;
  }
  var t114 = (1 + inputsh62) * r114;

  var t102 = t111 + t117 + t114 + t118;

  var t104 = t101 / r101 - 1;
  var t105 = parseFloat(t102 / r102 - 1) || 0;

  var t121 = roundToTwo((1 + inputsh70) * r121);

  var t122 = roundToTwo((1 + inputsh71) * r122);

  var r135 = inputsf75;
  var t135 = r135;
  var t136 = (1 + inputsh84) * r136;
  var r137 = inputsf87;
  var t137 = r137;
  var r138 = inputsf98;
  var t138 = r138;
  var t139 = inputsh103;

  var t140 =
    t111 * t135 + t113 * t136 + t116 * t137 + t118 * t138 + t139 + t121 * t136;
  var t141 =
    t102 > 0
      ? t111 * t135 +
        t114 * t136 +
        t117 * t137 +
        t118 * t138 +
        t139 +
        t122 * t136
      : 0;

  var r10 = data.results
    .filter((a) => a.fieldName == "practiceProfile")[0]
    .value.filter((b) => b.fieldName == "separateRole")[0].value;
  var r12 = data.results
    .filter((a) => a.fieldName == "practiceProfile")[0]
    .value.filter((b) => b.fieldName == "showHourly")[0].value;

  var r144 = !r10 ? inputsf78 + inputsf77 + inputsf76 : inputsf76;

  var t144 = r144;
  var t145 = (1 + inputsh81) * r145;
  var r146 = !r10 ? inputsf88 + inputsf89 + inputsf90 : inputsf88;

  var t146 = (1 + inputsh100) * r146;
  var t147 = r147 * (1 + inputsh93);
  var r148 = !r10 ? inputsf99 + inputsf100 + inputsf101 : inputsf99;
  var t148 = r148;
  var t149 = !r10 ? inputsh106 + inputsh105 + inputsh104 : inputsh104;

  var t150 =
    t111 * t144 +
    t113 * t145 +
    t116 * t146 +
    t118 * t148 +
    t149 +
    t147 * t101 +
    t145 * t121;
  var t151 =
    r102 > 0
      ? t111 * t144 +
        t114 * t145 +
        t117 * t146 +
        t118 * t148 +
        t149 +
        t147 * t102 +
        t122 * t145
      : 0;

  var r154 = !r10 ? 0 : inputsf77;

  var t154 = r154;

  var t155 = r155 * (1 + inputsh82);
  var r156 = !r10 ? 0 : inputsf98;
  var t156 = r156 * (1 + inputsh82);

  var t157 = r157 * (1 + inputsh94);
  var r158 = !r10 ? 0 : inputsf89;
  var t158 = r158;
  var t159 = !r10 ? 0 : inputsh105;
  var r112 = 0;
  // if (r101 != 0) {
  //   r112 = r101 - r111 - r118 - r116;
  // }
  var t160 =
    t111 * t154 + t113 * t155 + t116 * t156 + t118 * t158 + t159 + t157 * t101;
  var t161 =
    r112 > 0
      ? t111 * t154 +
        t114 * t155 +
        t117 * t156 +
        t118 * t158 +
        t159 +
        t157 * t102
      : 0;

  var r164 = !r10 ? 0 : inputsf78;
  var t164 = r164;
  var t165 = (1 + inputsh83) * r165;
  var r166 = !r10 ? 0 : inputsf90;
  var t166 = r166;

  var t167 = (1 + inputsh95) * r167;

  var r168 = !r10 ? 0 : inputsf101;
  var t168 = r168;

  var r169 = !r10 ? 0 : inputsh106;
  var t169 = r169;
  var t170 =
    t111 * t164 + t113 * t165 + t116 * t166 + t118 * t168 + t169 + t167 * t101;

  var t171 =
    r122 > 0
      ? t111 * t164 +
        t114 * t165 +
        t117 * t166 +
        t118 * t168 +
        t169 +
        t167 * t102
      : 0;
  var u176 = r176 > inputsi150 ? inputsi150 : r176;
  var t176 = (r176 + u176) / 2;

  var u177 = r177 > inputsi151 ? inputsi151 : r177;
  var t177 = (r177 + u177) / 2;

  var r185 = inputsf122;
  var t185 = r185;
  var r189 = inputsf144;
  var r187 = r180 - r185 - r189;

  var t187 = (1 + inputsh113) * r187;
  var t189 = inputsf144;
  var t180 = t185 + t187 + t189;

  var t190 = (1 + inputsh119) * r192;

  var t193 = (1 + inputsh120) * r193;

  var r207 = inputsf123;
  var t207 = r207;
  var t208 = (1 + inputsh131) * r208;

  var r209 = inputsf145;
  var t209 = r209;
  var t192 = (1 + inputsh119) * r192;

  var t210 = inputsh139;
  // var t211 = t185 * t207 + t187 * t208 + t189 * t209 + t210;//old
  var t211 = t185 * t207 + t187 * t208 + t189 * t209 + t210 + t192 * t208;

  var r188 = 0;

  if (r181 != 0) {
    r188 = r181 - r185 - r189;
  }

  var t188 = parseFloat((1 + inputsh114) * r188) || 0;

  var t181 = parseFloat(t185 + t188 + t189) || 0;

  var t212 =
    t181 == 0
      ? 0
      : t185 * t207 + t188 * t208 + t189 * t209 + t210 + t193 * t208;

  var r215 = r10 ? inputsf126 : inputsf124 + inputsf125 + inputsf126;
  var t215 = r215;
  var t216 = (1 + inputsh130) * r216;
  var t217 = (1 + inputsh136) * r217;

  var r218 = !r10 ? inputsf146 + inputsf147 + inputsf148 : inputsf148;
  var t218 = r218;

  var t219 = !r10 ? inputsh140 + inputsh141 + inputsh142 : inputsh142;
  // var t220 = t185 * t215 + t187 * t216 + t189 * t218 + t219 + t217 * t180;//old
  var t220 =
    t185 * t215 + t187 * t216 + t189 * t218 + t219 + t217 * t180 + t192 * t216;

  var t221 =
    t181 == 0
      ? 0
      : t185 * t215 +
        t188 * t216 +
        t189 * t218 +
        t219 +
        t217 * t181 +
        t216 * t193;

  var r224 = !r10 ? 0 : inputsf125;
  var t224 = r224;

  var t225 = (1 + inputsh129) * r225;
  //changed
  var inputsh135 = 0;
  var t226 = (1 + inputsh135) * r226;
  var r227 = !r10 ? 0 : inputsf147;
  var t227 = r227;

  var t228 = !r10 ? 0 : inputsh141;
  var t229 = t224 * t185 + t187 * t225 + t227 * t189 + t180 * t226 + t228;
  var t230 = t224 * t185 + t188 * t225 + t227 * t189 + t181 * t226 + t228;
  var r233 = r204 == 0 ? 0 : inputsf124;

  var t233 = !r10 ? 0 : r233;

  var t234 = (1 + inputsh128) * r234;
  var t235 = (1 + inputsh134) * r235;

  var r236 = !r10 ? 0 : inputsf146;
  var t236 = r236;
  var t237 = !r10 ? 0 : inputsh140;

  var t238 = t233 * t185 + t187 * t234 + t236 * t189 + t180 * t235 + t237;

  var t239 = t233 * t185 + t188 * t234 + t236 * t189 + t181 * t235 + t237;

  var monitoring_d8 = r24 + r25 + r28 + r29;

  var monitoring_e9 = (r24 / monitoring_d8) * 100;

  var monitoring_e10 = (r25 / monitoring_d8) * 100;
  var monitoring_e11 = (r28 / monitoring_d8) * 100;
  var monitoring_e12 = (r29 / monitoring_d8) * 100;

  var averageDurationToday =
    (monitoring_e9 / 100) * r97 +
    (monitoring_e10 / 100) * r98 +
    (monitoring_e11 / 100) * r176 +
    (monitoring_e12 / 100) * r177;

  var averageDurationLow =
    (monitoring_e9 / 100) * t97 +
    (monitoring_e10 / 100) * t98 +
    (monitoring_e11 / 100) * t176 +
    (monitoring_e12 / 100) * t177;

  var averageDurationHigh =
    (monitoring_e9 / 100) * u97 +
    (monitoring_e10 / 100) * u98 +
    (monitoring_e11 / 100) * u176 +
    (monitoring_e12 / 100) * u177;

  /***** Number of scheduled appointments per patient over the treatment */

  var numberOfScheduledToday =
    (monitoring_e9 / 100) * r101 +
    (monitoring_e10 / 100) * r102 +
    (monitoring_e11 / 100) * r180 +
    (monitoring_e12 / 100) * r181;

  var numberOfScheduledLow =
    (monitoring_e9 / 100) * t101 +
    (monitoring_e10 / 100) * t102 +
    (monitoring_e11 / 100) * t180 +
    (monitoring_e12 / 100) * t181;

  var u111 = r111;

  var u113 = (1 + inputsi61) * r113;

  var u107 = (1 + inputsi64) * r107;
  var u118 = r118;

  var u116 = u107;

  var u101 = u111 + u116 + u113 + u118;

  var u108 = (1 + inputsi65) * r108;
  var u117 = u108;
  var u185 = r185;

  var u187 = (1 + inputsi113) * r187;
  var u189 = r189;

  var u188 = parseFloat((1 + inputsi114) * r188) || 0;
  var u181 = parseFloat(u185 + u188 + u189) || 0;
  var u180 = u185 + u187 + u189;

  var u114 = (1 + inputsi62) * r114;
  var u102 = u111 + u117 + u114 + u118;

  var numberOfScheduledHigh =
    (monitoring_e9 / 100) * u101 +
    (monitoring_e10 / 100) * u102 +
    (monitoring_e11 / 100) * u180 +
    (monitoring_e12 / 100) * u181;

  /****** % reduction in the number of Check-up/ Adjustment appointments over the treatment */
  var reductionCheckupLow = numberOfScheduledLow / numberOfScheduledToday - 1;

  var reductionCheckupHigh = numberOfScheduledHigh / numberOfScheduledToday - 1;

  /**
   * Number of emergency appointments per patient over the treatment
   */

  var numberOfEmergencyToday =
    (monitoring_e9 / 100) * r121 +
    (monitoring_e10 / 100) * r122 +
    (monitoring_e11 / 100) * r192 +
    (monitoring_e12 / 100) * r193;

  var t187 = (1 + inputsh113) * r187;

  var t189 = inputsf144;

  var numberOfEmergencyLow =
    (monitoring_e9 / 100) * t121 +
    (monitoring_e10 / 100) * t122 +
    (monitoring_e11 / 100) * t192 +
    (monitoring_e12 / 100) * t193;

  var u121 = (1 + inputsi70) * r121;

  var u122 = (1 + inputsi71) * r122;

  var u192 = (1 + inputsi119) * r192;
  var u193 = (1 + inputsi120) * r193;

  var numberOfEmergencyHigh =
    (monitoring_e9 / 100) * u121 +
    (monitoring_e10 / 100) * u122 +
    (monitoring_e11 / 100) * u192 +
    (monitoring_e12 / 100) * u193;

  /**
   * Total number of appointments per patient over the treatment
   */
  var totalNumberToday = numberOfScheduledToday + numberOfEmergencyToday;
  var totalNumberLow = numberOfScheduledLow + numberOfEmergencyLow;
  var totalNumberHigh = numberOfScheduledHigh + numberOfEmergencyHigh;

  /**
   * reduction of total number of appointments over the treatment
   */

  var percentageReductionLow = totalNumberLow / totalNumberToday - 1;
  var percentageReductionHigh = totalNumberHigh / totalNumberToday - 1;

  /**
   *  reduction in the number of emergency appointments over the treatment
   */

  var reductionEmergencyLow = numberOfScheduledLow / numberOfScheduledToday - 1;
  var reductionEmergencyHigh =
    numberOfScheduledHigh / numberOfScheduledToday - 1;

  /**
   * REDUCE TIME SPENT
   */
  /**
   * doctor time
   */
  //à voir avec clément
  var r139 = 0;
  var r141 = 0;

  if (r102 > 0) {
    // r141 = r111 * r135 + r114 * r136 + r117 * r137 + r118 * r138 + r139;//old
    r141 =
      r111 * r135 +
      r114 * r136 +
      r117 * r137 +
      r118 * r138 +
      r139 +
      r122 * r136;
  }
  //à voir avec clément
  var r210 = 0;
  // var r211 = r185 * r207 + r187 * r208 + r189 * r209 + r210;//old
  var r211 = r185 * r207 + r187 * r208 + r189 * r209 + r210 + r192 * r208;
  var r212 = 0;
  if (r181 != 0) {
    r212 = r185 * r207 + r188 * r208 + r189 * r209 + r210 + r193 * r208;
  }
  // var r140 = r111 * r135 + r113 * r136 + r116 * r137 + r118 * r138 + r139;//old
  var r140 =
    r111 * r135 + r113 * r136 + r116 * r137 + r118 * r138 + r139 + r121 * r136;

  var doctorTimeHourToday =
    ((monitoring_e9 / 100) * r140) / 60 +
    ((monitoring_e10 / 100) * r141) / 60 +
    ((monitoring_e11 / 100) * r211) / 60 +
    ((monitoring_e12 / 100) * r212) / 60;

  var doctorTimeHourLow =
    ((monitoring_e9 / 100) * t140) / 60 +
    ((monitoring_e10 / 100) * t141) / 60 +
    ((monitoring_e11 / 100) * t211) / 60 +
    ((monitoring_e12 / 100) * t212) / 60;

  var u135 = r135;

  var u136 = (1 + inputsi84) * r136;
  var u137 = r137;
  var u138 = r138;

  var u139 = inputsh103;
  var u141 = 0;
  if (u102 > 0) {
    u141 =
      u111 * u135 +
      u114 * u136 +
      u117 * u137 +
      u118 * u138 +
      u139 +
      u122 * u136;
  }
  var u140 =
    u111 * u135 + u113 * u136 + u116 * u137 + u118 * u138 + u139 + u121 * u136;
  var u207 = r207;

  var u209 = r209;
  var u210 = inputsi139;
  var u212 = 0;
  var u208 = (1 + inputsi131) * r208;

  if (u181 != 0) {
    u212 = u185 * u207 + u188 * u208 + u189 * u209 + u210 + u193 * u208;
  }

  // var u211 = u185 * u207 + u187 * u208 + u189 * u209 + u210;//old
  var u211 = u185 * u207 + u187 * u208 + u189 * u209 + u210 + u192 * u208;
  var doctorTimeHourHigh =
    ((monitoring_e9 / 100) * u140) / 60 +
    ((monitoring_e10 / 100) * u141) / 60 +
    ((monitoring_e11 / 100) * u211) / 60 +
    ((monitoring_e12 / 100) * u212) / 60;

  var r170 =
    r111 * r164 + r113 * r165 + r116 * r166 + r118 * r168 + r169 + r167 * r101;

  //a voir avec clément
  var r159 = 0;
  var r160 =
    r111 * r154 + r113 * r155 + r116 * r156 + r118 * r158 + r159 + r157 * r101;
  //a voir avec clément
  var r149 = 0;
  // var r150 =
  //   r111 * r144 + r113 * r145 + r116 * r146 + r118 * r148 + r149 + r147 * r101; //old

  var r150 =
    r111 * r144 +
    r113 * r145 +
    r116 * r146 +
    r118 * r148 +
    r149 +
    r147 * r101 +
    r145 * r121;

  var monitoring_g30 = r150 / 60;

  var monitoring_g31 = (r160 / 60) * (r10 ? 1 : 0);
  var monitoring_g32 = (r170 / 60) * (r10 ? 1 : 0);

  var monitoring_g29 = monitoring_g30 + monitoring_g31 + monitoring_g32;

  // var r151 =
  //   r102 > 0
  //     ? r111 * r144 +
  //       r114 * r145 +
  //       r117 * r146 +
  //       r118 * r148 +
  //       r149 +
  //       r147 * r102
  //     : 0; //old
  var r151 =
    r102 > 0
      ? r111 * r144 +
        r114 * r145 +
        r117 * r146 +
        r118 * r148 +
        r149 +
        r147 * r102 +
        r122 * r145
      : 0;

  var r161 =
    r112 > 0
      ? r111 * r154 +
        r114 * r155 +
        r117 * r156 +
        r118 * r158 +
        r159 +
        r157 * r102
      : 0;

  var r171 =
    r122 > 0
      ? r111 * r164 +
        r114 * r165 +
        r117 * r166 +
        r118 * r168 +
        r169 +
        r167 * r102
      : 0;
  var monitoring_g59 = r151 / 60;
  var monitoring_g60 = (r161 / 60) * (r10 ? 1 : 0);
  var monitoring_g61 = (r171 / 60) * (r10 ? 1 : 0);

  var monitoring_g58 = monitoring_g59 + monitoring_g60 + monitoring_g61;
  var r204 = r10 ? 1 : 0;

  //   var treatmentPriceToday =
  //   impliedCostToday /
  //   (monitoring_e9 * r27 +
  //     monitoring_e10 * r28 +
  //     monitoring_e11 * r38 +
  //     monitoring_e12 * r39);

  // var treatmentPriceLow =
  //   impliedCostLow /
  //   (monitoring_e9 * r27 +
  //     monitoring_e10 * r28 +
  //     monitoring_e11 * r38 +
  //     monitoring_e12 * r39);
  // var treatmentPriceHigh =
  //   impliedCostHigh /
  //   (monitoring_e9 * r27 +
  //     monitoring_e10 * r28 +
  //     monitoring_e11 * r38 +
  //     monitoring_e12 * r39);

  //à voir avec clément
  var r237 = 0;
  var r219 = 0;
  var r228 = 0;
  var r229 = r224 * r185 + r187 * r225 + r227 * r189 + r180 * r226 + r228;
  var r238 = r233 * r185 + r187 * r234 + r236 * r189 + r180 * r235 + r237;

  // var r220 = r185 * r215 + r187 * r216 + r189 * r218 + r219 + r217 * r180; //old
  var r220 =
    r185 * r215 + r187 * r216 + r189 * r218 + r219 + r217 * r180 + r192 * r216;

  var r221 = 0;
  if (r181 != 0) {
    r221 =
      r185 * r215 +
      r188 * r216 +
      r189 * r218 +
      r219 +
      r217 * r181 +
      r216 * r193;
  }
  var r239 = r233 * r185 + r188 * r234 + r236 * r189 + r181 * r235 + r237;
  var r230 = r224 * r185 + r188 * r225 + r227 * r189 + r181 * r226 + r228;
  var monitoring_g90 = (r238 / 60) * r204;
  var monitoring_g89 = (r229 / 60) * r204;
  var monitoring_g88 = r220 / 60;
  var monitoring_g87 = monitoring_g90 + monitoring_g89 + monitoring_g88;

  var monitoring_g117 = r221 / 60;
  var monitoring_g118 = (r230 / 60) * r204;
  var monitoring_g119 = (r239 / 60) * r204;

  var monitoring_g116 = monitoring_g117 + monitoring_g118 + monitoring_g119;

  var staffTimeOverToday =
    (monitoring_e9 / 100) * monitoring_g29 +
    (monitoring_e10 / 100) * monitoring_g58 +
    (monitoring_e11 / 100) * monitoring_g87 +
    (monitoring_e12 / 100) * monitoring_g116;

  /** --------------- */
  var monitoring_i59 = t151 / 60;
  var monitoring_i60 = (t161 / 60) * r204;
  var monitoring_i61 = (t171 / 60) * r204;

  var monitoring_i58 = monitoring_i59 + monitoring_i60 + monitoring_i61;

  var monitoring_i30 = t150 / 60;
  var monitoring_i31 = (t160 / 60) * r204;
  var monitoring_i32 = (t170 / 60) * r204;

  var monitoring_i29 = monitoring_i30 + monitoring_i31 + monitoring_i32;

  var monitoring_i90 = (t238 / 60) * r204;
  var monitoring_i89 = (t229 / 60) * r204;
  var monitoring_i88 = t220 / 60;

  var monitoring_i87 = monitoring_i90 + monitoring_i89 + monitoring_i88;
  var monitoring_i117 = t221 / 60;
  var monitoring_i118 = (t230 / 60) * r204;
  var monitoring_i119 = (t239 / 60) * r204;
  var monitoring_i116 = monitoring_i117 + monitoring_i118 + monitoring_i119;
  var staffTimeOverLow =
    (monitoring_e9 / 100) * monitoring_i29 +
    (monitoring_e10 / 100) * monitoring_i58 +
    (monitoring_e11 / 100) * monitoring_i87 +
    (monitoring_e12 / 100) * monitoring_i116;

  /** ---------  */
  var u145 = (1 + inputsi81) * r145;
  var u144 = r144;
  var u146 = (1 + inputsi100) * r146;
  var u151 = 0;
  var u148 = r148;
  var u149 = 0;

  var u149 = !r10 ? inputsi106 + inputsi105 + inputsi104 : inputsi104;
  var u161 = 0;
  var u154 = r154;
  var u155 = r155 * (1 + inputsi82);
  var u156 = r156;
  var u158 = r158;
  var u159 = !r10 ? 0 : inputsi105;
  var u157 = r157 * (1 + inputsf94);
  var u171 = 0;
  var u164 = r164;
  var u165 = (1 + inputsi83) * r165;
  var u166 = r166;
  var u167 = (1 + inputsi95) * r167;
  var u168 = r168;
  var u169 = !r10 ? 0 : inputsi106;
  var u147 = r147 * (1 + inputsi93);
  var u150 =
    u111 * u144 +
    u113 * u145 +
    u116 * u146 +
    u118 * u148 +
    u149 +
    u147 * u101 +
    u145 * u121;

  var u160 =
    u111 * u154 + u113 * u155 + u116 * u156 + u118 * u158 + u159 + u157 * u101;
  var u170 =
    u111 * u164 + u113 * u165 + u116 * u166 + u118 * u168 + u169 + u167 * u101;

  var u233 = t233;
  var u234 = (1 + inputsi128) * r234;
  var u236 = t236;
  var u237 = r204 == 1 ? inputsi140 : 0;
  var u235 = (1 + inputsi134) * r235;
  var u224 = t224;
  var u225 = (1 + inputsi129) * r225;
  var u227 = r227;
  var u226 = (1 + inputsi135) * r226;
  var u228 = r204 == 0 ? 0 : inputsi141;
  var u215 = r215;
  var u216 = (1 + inputsi130) * r216;
  var u218 = r218;
  var u219 = r204 == 0 ? inputsi140 + inputsi141 + inputsi142 : inputsi142;
  var u217 = (1 + inputsi136) * r217;
  var u221 =
    u181 == 0
      ? 0
      : u185 * u215 +
        u188 * u216 +
        u189 * u218 +
        u219 +
        u217 * u181 +
        u216 * u193;
  var u230 = u224 * u185 + u188 * u225 + u227 * u189 + u181 * u226 + u228;
  // var u220 = u185 * u215 + u187 * u216 + u189 * u218 + u219 + u217 * u180;//old
  var u220 =
    u185 * u215 + u187 * u216 + u189 * u218 + u219 + u217 * u180 + u192 * u216;
  var u229 = u224 * u185 + u187 * u225 + u227 * u189 + u180 * u226 + u228;
  var u239 = u233 * u185 + u188 * u234 + u236 * u189 + u181 * u235 + u237;

  var u238 = u233 * u185 + u187 * u234 + u236 * u189 + u180 * u235 + u237;

  if (r122 > 0) {
    u171 =
      u111 * u164 +
      u114 * u165 +
      u117 * u166 +
      u118 * u168 +
      u169 +
      u167 * u102;
  }
  if (r112 > 0) {
    u161 =
      u111 * u154 +
      u114 * u155 +
      u117 * u156 +
      u118 * u158 +
      u159 +
      u157 * u102;
  }

  if (r102 > 0) {
    u151 =
      u111 * u144 +
      u114 * u145 +
      u117 * u146 +
      u118 * u148 +
      u149 +
      u147 * u102 +
      u122 * u145;
  }
  var monitoring_u59 = u151 / 60;
  var monitoring_u60 = (u161 / 60) * r204;
  var monitoring_u61 = (u171 / 60) * r204;

  var monitoring_u58 = monitoring_u59 + monitoring_u60 + monitoring_u61;

  var monitoring_u30 = u150 / 60;
  var monitoring_u31 = (u160 / 60) * r204;
  var monitoring_u32 = (u170 / 60) * r204;

  var monitoring_u29 = monitoring_u30 + monitoring_u31 + monitoring_u32;

  var monitoring_u90 = (u238 / 60) * r204;
  var monitoring_u89 = (u229 / 60) * r204;
  var monitoring_u88 = u220 / 60;

  var monitoring_u87 = monitoring_u90 + monitoring_u89 + monitoring_u88;

  var monitoring_u117 = u221 / 60;
  var monitoring_u118 = (u230 / 60) * r204;
  var monitoring_u119 = (u239 / 60) * r204;
  var monitoring_u116 = monitoring_u117 + monitoring_u118 + monitoring_u119;

  var staffTimeOverHigh =
    (monitoring_e9 / 100) * monitoring_u29 +
    (monitoring_e10 / 100) * monitoring_u58 +
    (monitoring_e11 / 100) * monitoring_u87 +
    (monitoring_e12 / 100) * monitoring_u116;

  var dentalAssistantToday =
    (monitoring_e9 / 100) * monitoring_g30 +
    (monitoring_e10 / 100) * monitoring_g59 +
    (monitoring_e11 / 100) * monitoring_g88 +
    (monitoring_e12 / 100) * monitoring_g117;

  var dentalAssistantLow =
    (monitoring_e9 / 100) * monitoring_i30 +
    (monitoring_e10 / 100) * monitoring_i59 +
    (monitoring_e11 / 100) * monitoring_i88 +
    (monitoring_e12 / 100) * monitoring_i117;
  var dentalAssistantHigh =
    (monitoring_e9 / 100) * monitoring_u30 +
    (monitoring_e10 / 100) * monitoring_u59 +
    (monitoring_e11 / 100) * monitoring_u88 +
    (monitoring_e12 / 100) * monitoring_u117;

  var treatmentCoordinatorToday =
    (monitoring_e9 / 100) * monitoring_g31 +
    (monitoring_e10 / 100) * monitoring_g60 +
    (monitoring_e11 / 100) * monitoring_g89 +
    (monitoring_e12 / 100) * monitoring_g118;

  var treatmentCoordinatorLow =
    (monitoring_e9 / 100) * monitoring_i31 +
    (monitoring_e10 / 100) * monitoring_i60 +
    (monitoring_e11 / 100) * monitoring_i89 +
    (monitoring_e12 / 100) * monitoring_i118;
  var treatmentCoordinatorHigh =
    (monitoring_e9 / 100) * monitoring_u31 +
    (monitoring_e10 / 100) * monitoring_u60 +
    (monitoring_e11 / 100) * monitoring_u89 +
    (monitoring_e12 / 100) * monitoring_u118;

  var frontDeskToday =
    (monitoring_e9 / 100) * monitoring_g32 +
    (monitoring_e10 / 100) * monitoring_g61 +
    (monitoring_e11 / 100) * monitoring_g90 +
    (monitoring_e12 / 100) * monitoring_g119;

  var frontDeskLow =
    (monitoring_e9 / 100) * monitoring_i32 +
    (monitoring_e10 / 100) * monitoring_i61 +
    (monitoring_e11 / 100) * monitoring_i90 +
    (monitoring_e12 / 100) * monitoring_i119;
  var frontDeskHigh =
    (monitoring_e9 / 100) * monitoring_u32 +
    (monitoring_e10 / 100) * monitoring_u61 +
    (monitoring_e11 / 100) * monitoring_u90 +
    (monitoring_e12 / 100) * monitoring_u119;

  var practiceTimeToday = doctorTimeHourToday + staffTimeOverToday;
  var practiceTimeLow = doctorTimeHourLow + staffTimeOverLow;
  var practiceTimeHigh = doctorTimeHourHigh + staffTimeOverHigh;

  var timeSavedLow = practiceTimeLow - practiceTimeToday;
  var timeSavedHigh = practiceTimeHigh - practiceTimeToday;

  var impliedCostToday =
    doctorTimeHourToday * r67 +
    dentalAssistantToday * r64 +
    treatmentCoordinatorToday * r65 +
    frontDeskToday * r66;
  var impliedCostLow =
    doctorTimeHourLow * r67 +
    dentalAssistantLow * r64 +
    treatmentCoordinatorLow * r65 +
    frontDeskLow * r66;
  var impliedCostHigh =
    doctorTimeHourHigh * r67 +
    dentalAssistantHigh * r64 +
    treatmentCoordinatorHigh * r65 +
    frontDeskHigh * r66;

  var impliedStaffLow =
    (dentalAssistantLow - dentalAssistantToday) * r64 +
    r65 * (treatmentCoordinatorLow - treatmentCoordinatorToday) +
    r66 * (frontDeskLow - frontDeskToday);

  var impliedStaffHigh =
    (dentalAssistantHigh - dentalAssistantToday) * r64 +
    r65 * (treatmentCoordinatorHigh - treatmentCoordinatorToday) +
    r66 * (frontDeskHigh - frontDeskToday);

  var impliedDoctorLow = (doctorTimeHourLow - doctorTimeHourToday) * r67;
  var impliedDoctorHigh = (doctorTimeHourHigh - doctorTimeHourToday) * r67;

  var practiceSalaryLow = r12 ? impliedDoctorLow + impliedStaffLow : 0;
  var practiceSalaryHigh = r12 ? impliedDoctorHigh + impliedStaffHigh : 0;

  /**
   * increase your profitability
   */

  var monitoring_d13 =
    (monitoring_e9 / 100) * r33 +
    (monitoring_e10 / 100) * r34 +
    (monitoring_e11 / 100) * r41 +
    (monitoring_e12 / 100) * r42;

  var revenuePerAppointmentToday = monitoring_d13 / totalNumberToday;
  var revenuePerAppointmentLow = monitoring_d13 / totalNumberLow;
  var revenuePerAppointmentHigh = monitoring_d13 / totalNumberHigh;

  var percentageWithoutDMLow =
    parseFloat(revenuePerAppointmentLow / revenuePerAppointmentToday - 1) || 0;
  var percentageWithoutDMHigh =
    parseFloat(revenuePerAppointmentHigh / revenuePerAppointmentToday - 1) || 0;

  /**
   * retention guarantee
   */

  var nbTreatmentStartToday = r25 + r24 + r28 + r29;
  var nbTreatmentStartLow = nbTreatmentStartToday;
  var nbTreatmentStartHigh = nbTreatmentStartToday;

  var percentageTakeUpLow = inputsh158;
  var percentageTakeUpHigh = inputsi158;

  var percentageCurrentPracticeToday = r251;
  var percentageCurrentPracticeLow =
    percentageCurrentPracticeToday - percentageTakeUpLow;
  var percentageCurrentPracticeHigh =
    percentageCurrentPracticeToday - percentageTakeUpHigh;

  var retentionGuaranteeLow = inputsh159;
  var retentionGuaranteeHigh = inputsi159;

  var additionalProductLow =
    nbTreatmentStartLow * percentageTakeUpLow * retentionGuaranteeLow;

  var additionalProductHigh =
    nbTreatmentStartHigh * percentageTakeUpHigh * retentionGuaranteeHigh;

  var r23 = r24 + r25;
  var r27 = r28 + r29;
  var r47 = (r24 * r37 + r25 * r38 + r28 * r45 + r29 * r46) / (r23 + r27);

  var productionFromRetentionToday =
    nbTreatmentStartToday * percentageCurrentPracticeToday * r47;
  var productionFromRetentionLow =
    nbTreatmentStartLow * percentageCurrentPracticeLow * r47;
  var productionFromRetentionHigh =
    nbTreatmentStartHigh * percentageCurrentPracticeHigh * r47;

  //a voir avec clément
  var productionTreatmentStartsToday =
    nbTreatmentStartToday * 0 * 0 + productionFromRetentionToday;

  var productionTreatmentStartsLow =
    nbTreatmentStartLow * percentageTakeUpLow * retentionGuaranteeLow +
    productionFromRetentionLow;
  var productionTreatmentStartsHigh =
    nbTreatmentStartHigh * percentageTakeUpHigh * retentionGuaranteeHigh +
    productionFromRetentionHigh;

  var increaseInProductionLow =
    productionTreatmentStartsLow - productionTreatmentStartsToday;
  var increaseInProductionHigh =
    productionTreatmentStartsHigh - productionTreatmentStartsToday;

  /**
   * relapse rate
   */

  var reductionRelapseRateLow = inputsh161;
  var reductionRelapseRateHigh = inputsi161;

  var relapseFiveYearToday =
    ((r257 / 100) * (r25 + r29)) / (r23 + r27) +
    (r258 / 100) * (1 - (r25 + r29) / (r23 + r27));

  var relapseFiveYearLow =
    inputsi162 > (1 + reductionRelapseRateLow) * relapseFiveYearToday
      ? (1 + reductionRelapseRateLow) * relapseFiveYearToday
      : inputsi162;

  var relapseFiveYearHigh =
    inputsi162 > (1 + reductionRelapseRateHigh) * relapseFiveYearToday
      ? (1 + reductionRelapseRateHigh) * relapseFiveYearToday
      : inputsi162;

  /**
   * Impact on the number of treatment starts per year
   */

  var incLeads = state.incLeads;
  var incConversion = state.incConversion;
  var vision = state.vision;
  var usingGrowth = state.usingGrowth;
  var usingRetention = state.usingRetention;
  var alignersAverage = state.alignersAverage;
  var alignersTeen = state.alignersTeen;
  var bracesAverage = state.bracesAverage;
  var bracesTeen = state.bracesTeen;
  var usingGrowthOther = state.usingGrowthOther;
  var usingRetentionOther = state.usingRetentionOther;

  var leadsForOrthoToday = (r23 * r27) / (r77 * r78);
  var leadsForOrthoLow =
    leadsForOrthoToday * (1 + inputsh40 * (incLeads ? 1 : 0));
  var leadsForOrthoHigh =
    leadsForOrthoToday * (1 + inputsi40 * (incLeads ? 1 : 0));

  /**
   * summary 1
   */
  //1
  var g151 = (r23 + r27) / ((r77 / 100) * (r78 / 100));

  var i151 = g151 * (1 + inputsh40 * (incLeads ? 1 : 0));
  var j151 = g151 * (1 + inputsi40 * (incLeads ? 1 : 0));

  // //2
  var g152 = r77;
  var g155 = r78;
  var g156 = 1 * g152 * (g155 / 100);
  var i154 = inputsh42;
  var j154 = inputsi42;
  var i152 =
    0.9 < inputsh41 * (incConversion ? 1 : 0) + g152 / 100
      ? 0.9
      : inputsh41 * (incConversion ? 1 : 0) + g152 / 100;

  var j152 =
    0.9 < inputsi41 * (incConversion ? 1 : 0) + g152 / 100
      ? 0.9
      : inputsi41 * (incConversion ? 1 : 0) + g152 / 100;

  var j155 = (incConversion ? j154 : 0) + g155 / 100;
  var i155 = (incConversion ? i154 : 0) + g155 / 100;

  var j156 = 1 * i152 * i155;
  var i156 = 1 * j152 * j155;

  // //3
  var g157 = g151 * (g152 / 100) * (g155 / 100);

  var i157 = i151 * i152 * i155;
  var j157 = j151 * j152 * j155;

  // //4
  var g159 = r56;
  var x_low = g159 * (1 + inputsh155) < 0.95 ? g159 * (1 + inputsh155) : 0.95;
  var i159 = usingGrowth ? x_low : g159;
  var x_high = g159 * (1 + inputsi155) < 0.95 ? g159 * (1 + inputsi155) : 0.95;

  var j159 = usingGrowth ? x_high : g159;
  ///5
  var g161 = r55 * g159;
  var i161 = t55 * i159;
  var j161 = u55 * j159;

  var i162 = i161 - g161;

  // //6
  var g162 = 0;
  var j162 = j161 - g161;

  var g163 = g157 + g162;

  var i164_new = !incLeads && !incConversion ? inputsh153 * i157 : 0;
  var j164_new = !incLeads && !incConversion ? inputsi153 * j157 : 0;
  // var i163 = i157 + i162;//old
  var i163 = i157 + i162 + i164_new;
  var j163 = j157 + j162 + j164_new;
  //7
  var i164 = i163 / g163 - 1;
  var j164 = j163 / g163 - 1;

  //8

  var g175 = r20 - r23 - r27;

  var g173 = r73 / 100;
  var g172 = r72 / 100;

  var g174 = 1 * g172 * g173;

  var g171 = g175 / g174;
  var i171 = g171 * (1 + inputsh40 * (incLeads ? 1 : 0));

  var j171 = g171 * (1 + inputsi40 * (incLeads ? 1 : 0));

  var j172 =
    0.9 < inputsi41 * (incConversion ? 1 : 0) + g172
      ? 0.9
      : inputsi41 * (state.incConversion ? 1 : 0) + g172;

  var i172 =
    0.9 < inputsh41 * (incConversion ? 1 : 0) + g172
      ? 0.9
      : inputsh41 * (incConversion ? 1 : 0) + g172;

  var i173 =
    0.9 < inputsh42 * (incConversion ? 1 : 0) + g173
      ? 0.9
      : inputsh42 * (incConversion ? 1 : 0) + g173;
  var j173 =
    0.9 < inputsi42 * (incConversion ? 1 : 0) + g173
      ? 0.9
      : inputsi42 * (incConversion ? 1 : 0) + g173;
  var i174 = 1 * i172 * i173;
  var j174 = 1 * j172 * j173;

  //9
  var i175 = i171 * i174;

  var j175 = j171 * j174;
  //10
  // var g177 = g175 + g157;//old
  var g177 = g175 + g163;
  // var i177 = i175 + i157;//old
  var i177 = i175 + i163;

  // var g177 = g175 + g157;//old
  var j177 = j175 + j163;
  //11
  var i178 = i177 / g177 - 1;
  var j178 = j177 / g177 - 1;

  /**
   * summary 2
   */
  //1
  var g194 = g163;
  var i194 = i163;
  var j194 = j163;
  //3
  var g167 = r28;
  var g168 = r29;
  var g165 = r24;
  var f165 = g165 / g163;

  var g166 = r25;
  var f166 = g166 / g163;
  var f167 = g167 / g163;
  var f168 = g168 / g163;

  var monitoring_g22 = r101;

  var monitoring_g51 = r102;
  var monitoring_g80 = r180;

  var monitoring_g109 = r181;

  var monitoring_i22 = t101;
  var monitoring_i51 = t102;
  var monitoring_i80 = t180;
  var monitoring_i109 = t181;

  var monitoring_j22 = u101;
  var monitoring_j51 = u102;
  var monitoring_j80 = u180;
  var monitoring_j109 = u181;

  var g34 =
    f165 * monitoring_g22 +
    f166 * monitoring_g51 +
    f167 * monitoring_g80 +
    f168 * monitoring_g109;

  var i34 =
    f165 * (alignersAverage ? monitoring_i22 + t121 : monitoring_g22 + r121) +
    f166 * (alignersTeen ? monitoring_i51 + t122 : monitoring_g51 + r122) +
    f167 * (bracesAverage ? monitoring_i80 + t192 : monitoring_g80 + r192) +
    f168 * (bracesTeen ? monitoring_i109 + t193 : monitoring_g109 + r193);
  var j34 =
    f165 * (alignersAverage ? monitoring_j22 + u121 : monitoring_g22 + r121) +
    f166 * (alignersTeen ? monitoring_j51 + u122 : monitoring_g51 + r122) +
    f167 * (bracesAverage ? monitoring_j80 + u192 : monitoring_g80 + r192) +
    f168 * (bracesTeen ? monitoring_j109 + u193 : monitoring_g109 + r193);

  // var g196 = g194 * g34; //old
  var g196 =
    g157 * totalNumberToday +
    (((r24 + r28) / ((r77 / 100) * (r78 / 100))) * (r77 / 100) +
      ((r20 - r24 - r28) / (1 * (r72 / 100) * (r73 / 100))) * (r72 / 100) +
      0 / r78);
  var temp = incLeads ? 1 : 0;

  var temp2 = !incLeads && !incConversion ? inputsh153 * i157 : 0;
  var temp3 = !incLeads && !incConversion ? inputsi153 * j157 : 0;
  // var i196 = i194 * i34;//old
  var i196 =
    i194 * i34 +
    ((r24 + r28) / ((r77 / 100) * (r78 / 100))) *
      (1 + temp * inputsh40) *
      i152 +
    ((r20 - r24 - r28) / (1 * (r72 / 100) * (r73 / 100))) *
      (1 + temp * inputsh40) *
      i172 +
    temp2 / ((incConversion ? inputsh42 : 0) + r78 / 100);

  var j196 =
    j194 * j34 +
    ((r24 + r28) / ((r77 / 100) * (r78 / 100))) *
      (1 + temp * inputsi40) *
      j152 +
    ((r20 - r24 - r28) / (1 * (r72 / 100) * (r73 / 100))) *
      (1 + temp * inputsi40) *
      j172 +
    temp3 / ((incConversion ? inputsi42 : 0) + r78 / 100);

  var i195 = i196 / g196 - 1;
  var j195 = j196 / g196 - 1;

  //4
  var i197 = i196 / g196 - 1;
  var j197 = j196 / g196 - 1;

  // //5

  var g198 = g165 * r33 + g166 * r34 + g167 * r41 + g168 * r42;

  var g100 = r25 + r24 + r29 + r28;
  var g102 = 0;
  var g103 = 0;
  var g101 = r251 / 100;
  var g106 = g101 * g100 * r47;
  var g199 = (g100 * g102 * g103 + g106) * 100;

  var g205 = g198 + g199;

  var i165 = f165 * i163;

  var i166 = f166 * i163;

  var i168 = f168 * i163;
  var i167 = f167 * i163;
  var i198 = i165 * r33 + i166 * r34 + i167 * r41 + i168 * r42;

  var g203 = r251;

  var i203 = g203 - inputsh158 * (usingRetention ? 1 : 0);

  var i204 = i203 * r47 * i194;

  var i200 = r47 * r251 * i194;
  var j165 = f165 * j163;
  var j166 = f166 * j163;
  var j167 = f167 * j163;
  var j168 = f168 * j163;
  var j203 = g203 - inputsi158 * (usingRetention ? 1 : 0);
  var j204 = j203 * r47 * j194;
  var j200 = r47 * r251 * j194;
  var j202 = inputsi159 * j194 * (g203 - j203);

  var j201 = j202 + j204;
  var j199 = usingRetention ? j201 : j200;
  var j198 = j165 * r33 + j166 * r34 + j167 * r41 + j168 * r42;
  var i202 = inputsh159 * i194 * (g203 - i203);

  var i201 = i202 + i204;
  var i199 = usingRetention ? i201 : i200;
  var i205 = i198 + i199;
  //i198 = i203 nv fichier
  var j205 = j198 + j199;
  // //6
  var g207 = g175;
  var i207 = i175;
  var j207 = j175;

  // //7

  var g208 = g207 * r21;
  var i208 = i207 * r21;
  var j208 = j207 * r21;

  //8
  var g209 = g205 + g208;
  var i209 = i205 + i208;
  var j209 = j205 + j208;

  //9

  var g217 = -(1 - inputsf49) * g208;
  var g225 = 0;
  var g226 = 0;
  var g227 = 0;
  var g229 = g225 + g226 + g227;

  var f216 =
    (f165 + f166) * (parseFloat(r127) + parseFloat(r128)) +
    (f167 + f168) * (parseFloat(r198) + parseFloat(r199));
  var g216 = -f216 * g194;

  var g215 = -r62 * g196;
  var g211 = -g194 * r253 * r251;
  var g210 = g211;
  var i214 = i203 * i194 * -r253;
  var i213 = i194 * (g203 - i203) * inputsh160;
  var i211 = -i194 * r253 * r251;

  var i212 = i213 + i214;
  var i210 = usingRetention ? i212 : i211;
  var g230 = g210 + g215 + g216 + g217 + g229;

  var i215 = -r62 * i196;

  var i216 = -f216 * i194;

  var i217 = -(1 - inputsf49) * i208;

  var varTotest = Math.round(i165 + i166);
  var i246 = 0;

  var list1 = [
    1,
    "0 to 30",
    data.inputs.pricing.tier1LicenseFee,
    data.inputs.pricing.tier1PerPatient,
    data.inputs.pricing.tier1Braces,
  ];

  var list = [
    21,
    "31 to 50",
    data.inputs.pricing.licenseFee,
    data.inputs.pricing.perPatient,
    data.inputs.pricing.bracesInput,
  ];
  var list2 = [
    51,
    "51 to 100",
    data.inputs.pricing.tier2LicenseFee,
    data.inputs.pricing.tier2PerPatient,
    data.inputs.pricing.tier2Braces,
  ];
  var list3 = [
    101,
    "101 to 200",
    data.inputs.pricing.tier3LicenseFee,
    data.inputs.pricing.tier3PerPatient,
    data.inputs.pricing.tier3Braces,
  ];
  var list4 = [
    201,
    "201 to 400",
    data.inputs.pricing.tier4LicenseFee,
    data.inputs.pricing.tier4PerPatient,
    data.inputs.pricing.tier4Braces,
  ];
  var list5 = [
    401,
    "400+",
    data.inputs.pricing.tier5LicenseFee,
    data.inputs.pricing.tier5PerPatient,
    data.inputs.pricing.tier5Braces,
  ];

  if (varTotest > list5[0]) {
    i246 = list5[3];
  }
  if (varTotest >= list4[0] && varTotest < list5[0]) {
    i246 = list4[3];
  }
  if (varTotest >= list3[0] && varTotest <= list4[0]) {
    i246 = list3[3];
  }
  if (varTotest >= list2[0] && varTotest <= list3[0]) {
    i246 = list2[3];
  }
  if (varTotest >= list[0] && varTotest <= list2[0]) {
    i246 = list[3];
  }
  if (varTotest >= list1[0] && varTotest <= list[0]) {
    i246 = list1[3];
  }

  var i248 = parseFloat(i166 / (i166 + i165)) || 0;
  var i249 = t97;

  var i251 = 0;
  var varTotest = Math.round(i167 + i168);
  if (varTotest > list5[0]) {
    i251 = list5[4];
  }
  if (varTotest >= list4[0] && varTotest < list5[0]) {
    i251 = list4[4];
  }
  if (varTotest >= list3[0] && varTotest <= list4[0]) {
    i251 = list3[4];
  }
  if (varTotest >= list2[0] && varTotest <= list3[0]) {
    i251 = list2[4];
  }
  if (varTotest >= list[0] && varTotest <= list2[0]) {
    i251 = list[4];
  }
  if (varTotest >= list1[0] && varTotest <= list[0]) {
    i251 = list1[4];
  }

  var i250 = t98;
  var i253 = parseFloat(i168 / (i167 + i168)) || 0;
  var i255 = t177;
  var i254 = t176;

  var i226 =
    -(
      (alignersAverage ? 1 : 0) * i165 +
      (alignersTeen ? 1 : 0) * i166 +
      (bracesAverage ? 1 : 0) * i167 +
      (bracesAverage ? 1 : 0) * i168
    ) * inputsf14;

  var i252 = i253 * i255 + (1 - i253) * i254;

  var i247 = i248 * i250 + (1 - i248) * i249;

  var i225 =
    -i246 * i247 * i165 * (alignersAverage ? 1 : 0) -
    i246 * i247 * i166 * (alignersTeen ? 1 : 0) -
    i251 * i252 * i167 * (bracesAverage ? 1 : 0) -
    i251 * i252 * i168 * (bracesTeen ? 1 : 0);

  var i227 =
    -(
      (alignersAverage ? 1 : 0) * i165 +
      (alignersTeen ? 1 : 0) * i166 +
      (bracesAverage ? 1 : 0) * i167 +
      (bracesTeen ? 1 : 0) * i168
    ) * inputsf15;

  var i228 = (incConversion || incLeads ? -inputsg18 : 0) * 12;

  var i229 = i225 + i226 + i227 + i228;
  var j213 = j194 * inputsi160 * (g203 - j203);
  var j214 = j203 * j194 * -r253;
  var j211 = -j194 * r253 * r251;
  var j212 = j213 + j214;

  var j210 = usingRetention ? j212 : j211;

  var j215 = -r62 * j196;
  var i230 = i210 + i215 + i216 + i217 + i229;

  var j216 = -f216 * j194;
  var j217 = -(1 - inputsf49) * j208;

  var j246 = 0;
  varTotest = Math.round(j165 + j166);
  if (varTotest > list5[0]) {
    j246 = list5[3];
  }
  if (varTotest >= list4[0] && varTotest < list5[0]) {
    j246 = list4[3];
  }
  if (varTotest >= list3[0] && varTotest <= list4[0]) {
    j246 = list3[3];
  }
  if (varTotest >= list2[0] && varTotest <= list3[0]) {
    j246 = list2[3];
  }
  if (varTotest >= list[0] && varTotest <= list2[0]) {
    j246 = list[3];
  }
  if (varTotest >= list1[0] && varTotest <= list[0]) {
    j246 = list1[3];
  }

  j246 = j246;

  var j254 = u176;
  var j251 = 0;

  var varTotest = Math.round(j167 + j168);
  if (varTotest > list5[0]) {
    j251 = list5[4];
  }
  if (varTotest >= list4[0] && varTotest < list5[0]) {
    j251 = list4[4];
  }
  if (varTotest >= list3[0] && varTotest <= list4[0]) {
    j251 = list3[4];
  }
  if (varTotest >= list2[0] && varTotest <= list3[0]) {
    j251 = list2[4];
  }
  if (varTotest >= list[0] && varTotest <= list2[0]) {
    j251 = list[4];
  }
  if (varTotest >= list1[0] && varTotest <= list[0]) {
    j251 = list1[4];
  }

  var j255 = u177;
  var j253 = parseFloat(j168 / (j167 + j168)) || 0;
  var j252 = j253 * j255 + (1 - j253) * j254;

  var j248 = parseFloat(j166 / (j166 + j165)) || 0;

  var j250 = u98;
  var j249 = u97;
  var j247 = j248 * j250 + (1 - j248) * j249;
  var j225 =
    -j246 * j247 * j165 * (alignersAverage ? 1 : 0) -
    j246 * j247 * j166 * (alignersTeen ? 1 : 0) -
    j251 * j252 * j167 * (bracesAverage ? 1 : 0) -
    j251 * j252 * j168 * (bracesTeen ? 1 : 0);

  var j226 =
    -(
      j165 * (alignersAverage ? 1 : 0) +
      j166 * (alignersTeen ? 1 : 0) +
      j167 * (bracesAverage ? 1 : 0) +
      j168 * (bracesTeen ? 1 : 0)
    ) * inputsf14;
  var j227 =
    -(
      j165 * (alignersAverage ? 1 : 0) +
      j166 * (alignersTeen ? 1 : 0) +
      j167 * (bracesAverage ? 1 : 0) +
      j168 * (bracesTeen ? 1 : 0)
    ) * inputsf15;

  var j228 = (incLeads || incConversion ? -inputsg18 : 0) * 12;
  var j229 = j225 + j226 + j227 + j228;

  var j230 = j210 + j215 + j216 + j217 + j229;

  // //10

  var g57 =
    (f165 * r140) / 60 +
    (f166 * r141) / 60 +
    (f167 * r211) / 60 +
    (f168 * r212) / 60;

  var g59 =
    (f165 * r150) / 60 +
    (f166 * r151) / 60 +
    (f167 * r220) / 60 +
    (f168 * r221) / 60;

  var g61 =
    f165 * (r170 / 60) * (r10 ? 1 : 0) +
    f166 * (r171 / 60) * (r10 ? 1 : 0) +
    f167 * (r238 / 60) * (r10 ? 1 : 0) +
    f168 * (r239 / 60) * (r10 ? 1 : 0);

  var g32 = (r170 / 60) * r10 ? 1 : 0;

  var g119 = (r239 / 60) * r10 ? 1 : 0;
  var g90 = (r238 / 60) * r10 ? 1 : 0;

  var monitoring_g31 = (r160 / 60) * (r10 ? 1 : 0);
  var monitoring_g60 = (r161 / 60) * (r10 ? 1 : 0);
  var monitoring_g89 = (r229 / 60) * (r10 ? 1 : 0);
  var monitoring_g118 = (r230 / 60) * (r10 ? 1 : 0);

  var g60 =
    f165 * monitoring_g31 +
    f166 * monitoring_g60 +
    f167 * monitoring_g89 +
    f168 * monitoring_g118;

  var g64 = g57 * r67 + g59 * r64 + g60 * r65 + g61 * r66;

  var g238 = -g208 * inputsf50;
  var i115 = t212 / 60;
  var g115 = r212 / 60;
  var i86 = t211 / 60;
  var g86 = r211 / 60;
  var i28 = t140 / 60;
  var g28 = r140 / 60;
  var i30 = t150 / 60;
  var g30 = r150 / 60;
  var i88 = t220 / 60;
  var g88 = r220 / 60;

  var monitoring_i28 = t140 / 60;
  var monitoring_g28 = r140 / 60;
  var monitoring_j28 = u140 / 60;

  var monitoring_i57 = t141 / 60;
  var monitoring_g57 = r141 / 60;
  var monitoring_j57 = u141 / 60;

  var monitoring_i86 = t211 / 60;
  var monitoring_g86 = r211 / 60;
  var monitoring_j86 = u211 / 60;

  var monitoring_i115 = t212 / 60;
  var monitoring_g115 = r212 / 60;
  var monitoring_j115 = u212 / 60;

  var i57 =
    f165 * (alignersAverage ? monitoring_i28 : monitoring_g28) +
    f166 * (alignersTeen ? monitoring_i57 : monitoring_g57) +
    f167 * (bracesAverage ? monitoring_i86 : monitoring_g86) +
    f168 * (bracesTeen ? monitoring_i115 : monitoring_g115);

  var i117 = t218 / 60;
  var g117 = r218 / 60;

  var monitoring_i31 = (t160 / 60) * (r10 ? 1 : 0);
  var monitoring_i60 = (t161 / 60) * (r10 ? 1 : 0);
  var monitoring_i89 = (t229 / 60) * (r10 ? 1 : 0);
  var monitoring_i118 = (t230 / 60) * (r10 ? 1 : 0);

  var monitoring_i30 = t150 / 60;
  var monitoring_j30 = u150 / 60;

  var monitoring_i59 = t151 / 60;
  var monitoring_g59 = r151 / 60;
  var monitoring_j59 = u151 / 60;

  var monitoring_i88 = t220 / 60;
  var monitoring_g88 = r220 / 60;
  var monitoring_j88 = u220 / 60;

  var monitoring_i117 = t221 / 60;
  var monitoring_g117 = r221 / 60;
  var monitoring_j117 = u221 / 60;

  var i60 =
    f165 * (alignersAverage ? monitoring_i31 : monitoring_g31) +
    f166 * (alignersTeen ? monitoring_i60 : monitoring_g60) +
    f167 * (bracesAverage ? monitoring_i89 : monitoring_g89) +
    f168 * (bracesTeen ? monitoring_i118 : monitoring_g118);

  var r60 = (r158 / 60) * r10 ? 1 : 0;
  var i32 = (t167 / 60) * r10 ? 1 : 0;
  var i90 = (t235 / 60) * r10 ? 1 : 0;
  var i119 = (t236 / 60) * r10 ? 1 : 0;
  var i238 = -(i208 * inputsf50);
  var j28 = u140 / 60;
  var j86 = u211 / 60;
  var j115 = u212 / 60;
  var j59 =
    f165 * (alignersAverage ? monitoring_j30 : monitoring_g30) +
    f166 * (alignersTeen ? monitoring_j59 : monitoring_g59) +
    f167 * (bracesAverage ? monitoring_j88 : monitoring_g88) +
    f168 * (bracesTeen ? monitoring_j117 : monitoring_g117);
  var monitoring_j31 = (u160 / 60) * (r10 ? 1 : 0);
  var monitoring_j60 = (u161 / 60) * (r10 ? 1 : 0);
  var monitoring_j89 = (u229 / 60) * (r10 ? 1 : 0);
  var monitoring_j118 = (u230 / 60) * (r10 ? 1 : 0);

  var j60 =
    f165 * (alignersAverage ? monitoring_j31 : monitoring_g31) +
    f166 * (alignersTeen ? monitoring_j60 : monitoring_g60) +
    f167 * (bracesAverage ? monitoring_j89 : monitoring_g89) +
    f168 * (bracesTeen ? monitoring_j118 : monitoring_g118);

  var monitoring_i32 = (t170 / 60) * (r10 ? 1 : 0);
  var monitoring_g32 = (r170 / 60) * (r10 ? 1 : 0);
  var monitoring_j32 = (u170 / 60) * (r10 ? 1 : 0);

  var monitoring_i61 = (t171 / 60) * (r10 ? 1 : 0);
  var monitoring_g61 = (r171 / 60) * (r10 ? 1 : 0);
  var monitoring_j61 = (u171 / 60) * (r10 ? 1 : 0);

  var monitoring_i90 = (t238 / 60) * (r10 ? 1 : 0);
  var monitoring_g90 = (r238 / 60) * (r10 ? 1 : 0);
  var monitoring_j90 = (u238 / 60) * (r10 ? 1 : 0);

  var monitoring_i119 = (t239 / 60) * (r10 ? 1 : 0);
  var monitoring_g119 = (r239 / 60) * (r10 ? 1 : 0);
  var monitoring_j119 = (u239 / 60) * (r10 ? 1 : 0);

  var j61 =
    f165 * (alignersAverage ? monitoring_j32 : monitoring_g32) +
    f166 * (alignersTeen ? monitoring_j61 : monitoring_g61) +
    f167 * (bracesAverage ? monitoring_j90 : monitoring_g90) +
    f168 * (bracesTeen ? monitoring_j119 : monitoring_g119);

  var j57 =
    f165 * (alignersAverage ? monitoring_j28 : monitoring_g28) +
    f166 * (alignersTeen ? monitoring_j57 : monitoring_g57) +
    f167 * (bracesAverage ? monitoring_j86 : monitoring_g86) +
    f168 * (bracesTeen ? monitoring_j115 : monitoring_g115);

  var j64 = j57 * r67 + j59 * r64 + j60 * r65 + j61 * r66;

  var summary_r61 =
    f165 * monitoring_g32 +
    f166 * monitoring_g61 +
    f167 * monitoring_g90 +
    f168 * monitoring_g119;

  var i61 =
    f165 * (alignersAverage ? monitoring_i32 : monitoring_g32) +
    f166 * (alignersTeen ? monitoring_i61 : monitoring_g61) +
    f167 * (bracesAverage ? monitoring_i90 : monitoring_g90) +
    f168 * (bracesTeen ? monitoring_i119 : monitoring_g119);
  var i59 =
    f165 * (alignersAverage ? monitoring_i30 : monitoring_g30) +
    f166 * (alignersTeen ? monitoring_i59 : monitoring_g59) +
    f167 * (bracesAverage ? monitoring_i88 : monitoring_g88) +
    f168 * (bracesTeen ? monitoring_i117 : monitoring_g117);

  var g58 =
    f165 * monitoring_g29 +
    f166 * monitoring_g58 +
    f167 * monitoring_g87 +
    f168 * monitoring_g116;

  var i64 = i57 * r67 + i59 * r64 + i60 * r65 + i61 * r66;

  var g234 = r12 == 0 ? 0 : -g64 * g194 + g238;

  var i234 = r12 == 0 ? 0 : -i64 * i194 + i238;

  var j238 = -(j208 * inputsf50);
  var g231 = g209 + g230;

  var j234 = r12 == 0 ? 0 : -j64 * j194 + j238;

  //11

  var g239 = r12 == 0 ? 0 : g231 + g234;

  var i231 = i209 + i230;
  var j231 = j209 + j230;

  var i239 = r12 == 0 ? 0 : i231 + i234;
  var j239 = r12 == 0 ? 0 : j231 + j234;

  //12
  var i241 = r12 == 0 ? 0 : i239 / g239 - 1;
  var j241 = r12 == 0 ? 0 : j239 / g239 - 1;

  //new indicator
  var g276 = r12 == 0 ? 0 : g209 + g230 + g234;
  var i276 = r12 == 0 ? 0 : i209 + i230 + i234;
  var j276 = r12 == 0 ? 0 : j209 + j230 + j234;

  var g277 = g276 * 1.3;
  var g279 = g276 / 12;
  var i279 = i276 / 12;
  var j279 = j276 / 12;
  var g281 = g279 != 0 ? g277 / g279 : 0;
  var i281 = i279 != 0 ? g277 / i279 : 0;
  var j281 = j279 != 0 ? g277 / j279 : 0;
  var i282 = Math.round(g281 - i281);
  var j282 = Math.round(g281 - j281);

  //aded by farouk
  var i152 = 0.9 < inputsh41 * (incConversion ? 1 : 0) + g152;
  var i158 = i151 * i152 * i155;
  var j158 = j151 * j152 * j155;

  //5%-10%
  var i199_new = (i163 + i175) / (g163 + g175) - 1;
  var j199_new = (j163 + j175) / (g163 + g175) - 1;

  //**** */
  var summaryFirst = r12 ? g239 : g231;
  var summarySecond = r12 ? j239 : j231;

  //adults
  var monitoring_j29 = monitoring_j30 + monitoring_j31 + monitoring_j32;

  var practiceTimeAlignersAdultsToday = monitoring_g28 + monitoring_g29;

  var practiceTimeAlignersAdultsHigh = monitoring_j28 + monitoring_j29;

  var practiceTimeAlignersTeensToday =
    monitoring_g57 + monitoring_g60 + monitoring_g61 + monitoring_g59;

  var practiceTimeAlignersTeensHigh =
    monitoring_j57 + monitoring_j60 + monitoring_j61 + monitoring_j59;

  var practiceTimeBracesAdultsToday = monitoring_g87 + monitoring_g86;
  var monitoring_j87 = monitoring_j90 + monitoring_j89 + monitoring_j88;

  var practiceTimeBracesAdultsHigh = monitoring_j87 + monitoring_j86;

  var practiceTimeBracesTeensToday = monitoring_g115 + monitoring_g116;
  var monitoring_j116 = monitoring_j117 + monitoring_j118 + monitoring_j119;

  var practiceTimeBracesTeensHigh = monitoring_j115 + monitoring_j116;

  //reduce appointment adults and teens
  var adultsAlignersTodayValue1 = r101;
  var adultsAlignersTodayValue3 = monitoring_g22 + r121;
  var adultsAlignersTodayValue2 =
    adultsAlignersTodayValue3 - adultsAlignersTodayValue1;

  var adultsAlignersHighValue1 = u101;
  var adultsAlignersHighValue3 = monitoring_j22 + u121;
  var adultsAlignersHighValue2 =
    adultsAlignersHighValue3 - adultsAlignersHighValue1;

  var teensAlignersTodayValue1 = monitoring_g51;
  var teensAlignersTodayValue3 = r122 + monitoring_g51;
  var teensAlignersTodayValue2 =
    teensAlignersTodayValue3 - teensAlignersTodayValue1;

  var teensAlignersHighValue1 = monitoring_j51;
  var teensAlignersHighValue3 = u122 + monitoring_j51;
  var teensAlignersHighValue2 =
    teensAlignersHighValue3 - teensAlignersHighValue1;

  //braces
  var adultsBracesTodayValue1 = r180;
  var adultsBracesTodayValue3 = r192 + r180;
  var adultsBracesTodayValue2 =
    adultsBracesTodayValue3 - adultsBracesTodayValue1;

  var adultsBracesHighValue1 = u180;
  var adultsBracesHighValue3 = u192 + u180;
  var adultsBracesHighValue2 = adultsBracesHighValue3 - adultsBracesHighValue1;

  var teensBracesTodayValue1 = r181;
  var teensBracesTodayValue3 = r193 + r181;
  var teensBracesTodayValue2 = teensBracesTodayValue3 - teensBracesTodayValue1;

  var teensBracesHighValue1 = u181;
  var teensBracesHighValue3 = u181 + u193;
  var teensBracesHighValue2 = teensBracesHighValue3 - teensBracesHighValue1;

  var summaryIncreseConversion =
    j151 * j152 * j155 -
    (j151 * j152 * g155) / 100 +
    j171 * j172 * j173 -
    j171 * j172 * g173;

  var summaryIncreaseStartRate =
    ((j152 * j151 - (g152 / 100) * j151) * g155) / 100 +
    (j172 * j171 - g172 * j171) * g173;

  var j169 = f165 * r33 + r34 * f166 + f167 * r41 + f168 * r42;

  var monitoring_g25 = r121 + r101;
  var monitoring_j25 = u121 + u101;
  var revenuPerAppointmentAlignersAdultsToday = r33 / monitoring_g25;
  var revenuPerAppointmentAlignersAdultsHigh = r33 / monitoring_j25;

  var monitoring_g54 = r122 + r102;
  var monitoring_j54 = u122 + u102;
  var revenuPerAppointmentAlignersTeensToday = r34 / monitoring_g54;
  var revenuPerAppointmentAlignersTeensHigh = r34 / monitoring_j54;

  var monitoring_g83 = r192 + r180;
  var monitoring_j83 = u192 + u180;

  var revenuPerAppointmentBracesAdultsToday = r41 / monitoring_g83;
  var revenuPerAppointmentBracesAdultsHigh = r41 / monitoring_j83;

  var monitoring_g112 = r193 + r181;
  var monitoring_j112 = u193 + u181;

  var revenuPerAppointmentBracesTeensToday = r42 / monitoring_g112;
  var revenuPerAppointmentBracesTeensHigh = r42 / monitoring_j112;
  var res = {
    reduceAppointment: {
      averageDurationToday: roundToOne(averageDurationToday),
      averageDurationLow: roundToOne(averageDurationLow),
      averageDurationHigh: roundToOne(averageDurationHigh),

      reductionCheckupLow: roundToOne(reductionCheckupLow * 100),
      reductionCheckupHigh: roundToOne(reductionCheckupHigh * 100),

      numberOfScheduledToday: roundToOne(numberOfScheduledToday),
      numberOfScheduledLow: roundToOne(numberOfScheduledLow),
      numberOfScheduledHigh: roundToOne(numberOfScheduledHigh),

      reductionEmergencyLow: roundToThree(reductionEmergencyLow),
      reductionEmergencyHigh: roundToThree(reductionEmergencyHigh),

      numberOfEmergencyToday: roundToOne(numberOfEmergencyToday),
      numberOfEmergencyLow: roundToOne(numberOfEmergencyLow),
      numberOfEmergencyHigh: roundToOne(numberOfEmergencyHigh),

      totalNumberToday: roundToOne(totalNumberToday),
      totalNumberLow: roundToOne(totalNumberLow),
      totalNumberHigh: roundToOne(totalNumberHigh),

      percentageReductionLow: roundToOne(percentageReductionLow * 100),
      percentageReductionHigh: roundToOne(percentageReductionHigh * 100),

      adultsAlignersTodayValue1: roundToOne(adultsAlignersTodayValue1),
      adultsAlignersTodayValue3: roundToOne(adultsAlignersTodayValue3),
      adultsAlignersTodayValue2: roundToOne(adultsAlignersTodayValue2),
      adultsAlignersHighValue1: roundToOne(adultsAlignersHighValue1),
      adultsAlignersHighValue3: roundToOne(adultsAlignersHighValue3),
      adultsAlignersHighValue2: roundToOne(adultsAlignersHighValue2),
      teensAlignersTodayValue1: roundToOne(teensAlignersTodayValue1),
      teensAlignersTodayValue3: roundToOne(teensAlignersTodayValue3),
      teensAlignersTodayValue2: roundToOne(teensAlignersTodayValue2),
      teensAlignersHighValue1: roundToOne(teensAlignersHighValue1),
      teensAlignersHighValue3: roundToOne(teensAlignersHighValue3),
      teensAlignersHighValue2: roundToOne(teensAlignersHighValue2),

      adultsBracesTodayValue1: roundToOne(adultsBracesTodayValue1),
      adultsBracesTodayValue3: roundToOne(adultsBracesTodayValue3),
      adultsBracesTodayValue2: roundToOne(adultsBracesTodayValue2),
      adultsBracesHighValue1: roundToOne(adultsBracesHighValue1),
      adultsBracesHighValue3: roundToOne(adultsBracesHighValue3),
      adultsBracesHighValue2: roundToOne(adultsBracesHighValue2),
      teensBracesTodayValue1: roundToOne(teensBracesTodayValue1),
      teensBracesTodayValue3: roundToOne(teensBracesTodayValue3),
      teensBracesTodayValue2: roundToOne(teensBracesTodayValue2),
      teensBracesHighValue1: roundToOne(teensBracesHighValue1),
      teensBracesHighValue3: roundToOne(teensBracesHighValue3),
      teensBracesHighValue2: roundToOne(teensBracesHighValue2),
    },
    reduceTimeSpent: {
      showHourly: r12,
      doctorTimeHourToday: roundToOne(doctorTimeHourToday),
      doctorTimeHourLow: roundToOne(doctorTimeHourLow),
      doctorTimeHourHigh: roundToOne(doctorTimeHourHigh),

      staffTimeOverToday: roundToOne(staffTimeOverToday),
      staffTimeOverLow: roundToOne(staffTimeOverLow),
      staffTimeOverHigh: roundToOne(staffTimeOverHigh),

      dentalAssistantToday: roundToOne(dentalAssistantToday),
      dentalAssistantLow: roundToOne(dentalAssistantLow),
      dentalAssistantHigh: roundToOne(dentalAssistantHigh),
      treatmentCoordinatorToday: roundToOne(treatmentCoordinatorToday),
      treatmentCoordinatorLow: roundToOne(treatmentCoordinatorLow),
      treatmentCoordinatorHigh: roundToOne(treatmentCoordinatorHigh),
      frontDeskToday: roundToOne(frontDeskToday),
      frontDeskLow: roundToOne(frontDeskLow),
      frontDeskHigh: roundToOne(frontDeskHigh),
      practiceTimeToday: roundToOne(practiceTimeToday),
      practiceTimeLow: roundToOne(practiceTimeLow),
      practiceTimeHigh: roundToOne(practiceTimeHigh),
      timeSavedLow: roundToOne(timeSavedLow),
      timeSavedHigh: roundToOne(timeSavedHigh),
      impliedCostToday: Math.round(impliedCostToday),
      impliedCostLow: Math.round(impliedCostLow),
      impliedCostHigh: Math.round(impliedCostHigh),

      // treatmentPriceToday: Math.round(treatmentPriceToday * 100),
      // treatmentPriceLow: Math.round(treatmentPriceLow * 100),
      // treatmentPriceHigh: Math.round(treatmentPriceHigh * 100),

      impliedStaffLow: Math.round(impliedStaffLow),
      impliedStaffHigh: Math.round(impliedStaffHigh),
      impliedDoctorLow: Math.round(impliedDoctorLow),
      impliedDoctorHigh: Math.round(impliedDoctorHigh),
      practiceSalaryLow: Math.round(practiceSalaryLow),
      practiceSalaryHigh: Math.round(practiceSalaryHigh),
      practiceTimeAlignersAdultsToday: roundToOne(
        practiceTimeAlignersAdultsToday,
      ),
      practiceTimeAlignersAdultsHigh: roundToOne(
        practiceTimeAlignersAdultsHigh,
      ),

      practiceTimeAlignersTeensToday: roundToOne(
        practiceTimeAlignersTeensToday,
      ),
      practiceTimeAlignersTeensHigh: roundToOne(practiceTimeAlignersTeensHigh),

      practiceTimeBracesTeensToday: roundToOne(practiceTimeBracesTeensToday),
      practiceTimeBracesTeensHigh: roundToOne(practiceTimeBracesTeensHigh),

      practiceTimeBracesAdultsToday: roundToOne(practiceTimeBracesAdultsToday),
      practiceTimeBracesAdultsHigh: roundToOne(practiceTimeBracesAdultsHigh),
    },
    impactOnProfitability: {
      revenuePerAppointmentToday: Math.round(
        roundToOne(revenuePerAppointmentToday),
      ),
      revenuePerAppointmentLow: Math.round(
        roundToOne(revenuePerAppointmentLow),
      ),
      revenuePerAppointmentHigh: Math.round(
        roundToOne(revenuePerAppointmentHigh),
      ),
      percentageWithoutDMLow: Math.round(percentageWithoutDMLow * 100),
      percentageWithoutDMHigh: Math.round(percentageWithoutDMHigh * 100),
      revenuPerAppointmentAlignersAdultsToday:
        revenuPerAppointmentAlignersAdultsToday,
      revenuPerAppointmentAlignersAdultsHigh:
        revenuPerAppointmentAlignersAdultsHigh,

      revenuPerAppointmentAlignersTeensToday:
        revenuPerAppointmentAlignersTeensToday,
      revenuPerAppointmentAlignersTeensHigh:
        revenuPerAppointmentAlignersTeensHigh,

      revenuPerAppointmentBracesAdultsToday:
        revenuPerAppointmentBracesAdultsToday,
      revenuPerAppointmentBracesAdultsHigh:
        revenuPerAppointmentBracesAdultsHigh,

      revenuPerAppointmentBracesTeensToday:
        revenuPerAppointmentBracesTeensToday,
      revenuPerAppointmentBracesTeensHigh: revenuPerAppointmentBracesTeensHigh,
    },
    summary: {
      summaryIncreaseStartRate: Math.round(summaryIncreaseStartRate),
      summaryIncreseConversion: Math.round(summaryIncreseConversion),
      summaryFirst: Math.round(summaryFirst),
      summarySecond: Math.round(summarySecond),
      g151: Math.round(g151),
      j169: Math.round(j169),
      j151: Math.round(j151),
      i151: Math.round(i151),
      g152: Math.round(g152),
      j152: Math.round(j152),
      g155: Math.round(g155),
      j155: Math.round(j155),
      g156: Math.round(g156),
      inputsh153: inputsh153,
      inputsi153: inputsi153,
      j156: Math.round(j156 * 100),
      i156: Math.round(i156 * 100),
      g157: Math.round(g157),
      j157: Math.round(j157),
      i157: Math.round(i157),
      g159: Math.round(100 * g159),
      i159: Math.round(100 * i159),
      j159: Math.round(100 * j159),
      g163: Math.round(g163),
      j163: Math.round(j163),
      i163: Math.round(i163),
      i162: roundToOne(i162),
      j162: roundToOne(j162),
      i164: Math.round(100 * i164),
      j164: Math.round(100 * j164),
      g171: roundToOne(g171),
      j171: roundToOne(j171),
      j172: roundToOne(j172),
      g172: roundToOne(g172),
      g173: roundToOne(g173),
      j173: roundToOne(j173),
      i171: roundToOne(i171),
      g174: g174,
      j174: roundToOne(j174),
      i174: roundToOne(i174),
      g175: Math.round(g175),
      j175: Math.round(j175),
      i175: Math.round(i175),
      g177: Math.round(g177),
      j177: Math.round(j177),
      i177: Math.round(i177),
      i178: Math.round(100 * i178),
      j178: Math.round(100 * j178),

      i195: Math.round(i195 * 100),
      j195: Math.round(j195 * 100),
      g196: Math.round(g196),
      i196: Math.round(i196),
      j196: Math.round(j196),
      i197: Math.round(i197 * 100),
      j197: Math.round(j197 * 100),
      g205: Math.round(g205),
      i205: Math.round(i205),
      j205: Math.round(j205),
      j208: roundToOne(j208),
      i208: roundToOne(i208),
      g208: roundToOne(g208),
      g209: Math.round(g209),
      i209: Math.round(i209),
      j209: Math.round(j209),
      g230: Math.round(g230),
      j230: Math.round(j230),
      i230: Math.round(i230),
      g234: Math.round(g234),
      j234: Math.round(j234),
      i234: Math.round(i234),
      g239: Math.round(g239),
      i239: Math.round(i239),
      j239: Math.round(j239),
      i241: Math.round(i241 * 100),
      j241: Math.round(j241 * 100),
      g276: g276,
      i276: i276,
      j276: j276,
      g277: g277,
      g279: Math.round(g279),
      i279: Math.round(i279),
      j279: Math.round(j279),
      g281: Math.round(g281),
      i281: Math.round(i281),
      j281: Math.round(j281),
      i282: i282,
      j282: j282,
      r262: Math.round(r262),
      i164_new: Math.round(i164_new),
      j164_new: Math.round(j164_new),
      i199_new: Math.round(i199_new * 100),
      j199_new: Math.round(j199_new * 100),
    },
    retentionGuarantee: {
      nbTreatmentStartToday: Math.round(nbTreatmentStartToday),
      nbTreatmentStartLow: Math.round(nbTreatmentStartLow),
      nbTreatmentStartHigh: Math.round(nbTreatmentStartHigh),
      percentageCurrentPracticeToday: Math.round(
        percentageCurrentPracticeToday * 100,
      ),
      percentageCurrentPracticeLow: Math.round(
        percentageCurrentPracticeLow * 100,
      ),
      percentageCurrentPracticeHigh: Math.round(
        percentageCurrentPracticeHigh * 100,
      ),
      percentageTakeUpLow: Math.round(percentageTakeUpLow * 100),
      percentageTakeUpHigh: Math.round(percentageTakeUpHigh * 100),

      retentionGuaranteeLow: Math.round(retentionGuaranteeLow),
      retentionGuaranteeHigh: Math.round(retentionGuaranteeHigh),
      additionalProductLow: Math.round(additionalProductLow),
      additionalProductHigh: Math.round(additionalProductHigh),
      productionFromRetentionToday: round(productionFromRetentionToday),
      productionFromRetentionLow: round(productionFromRetentionLow),
      productionFromRetentionHigh: round(productionFromRetentionHigh),
      productionTreatmentStartsToday: Math.round(
        productionTreatmentStartsToday,
      ),
      productionTreatmentStartsLow: Math.round(productionTreatmentStartsLow),
      productionTreatmentStartsHigh: Math.round(productionTreatmentStartsHigh),
      increaseInProductionLow: Math.round(increaseInProductionLow),
      increaseInProductionHigh: Math.round(increaseInProductionHigh),
    },
    relapseRate: {
      reductionRelapseRateLow:
        (reductionRelapseRateLow > 0 || -1) *
        Math.round(Math.abs(reductionRelapseRateLow * 100)),
      reductionRelapseRateHigh:
        (reductionRelapseRateHigh > 0 || -1) *
        Math.round(Math.abs(reductionRelapseRateHigh * 100)),
      relapseFiveYearToday: Math.round(relapseFiveYearToday * 100),
      relapseFiveYearLow: roundToOne(relapseFiveYearLow * 100),
      relapseFiveYearHigh: Math.round(relapseFiveYearHigh * 100),
    },
    /*numberTreatmentStart: {
      leadsForOrthoToday: leadsForOrthoToday,
      leadsForOrthoLow: leadsForOrthoLow,
      leadsForOrthoHigh: leadsForOrthoHigh,
      leadExamToday: leadExamToday,
      leadExamLow: leadExamLow,
      leadExamHigh: leadExamHigh,
    },*/
  };
  return res;
};

export const toFormatNumbers = (x, name) => {
  if (name == "euro") {
    name = "eur";
  }
  var language = window.navigator.userLanguage || window.navigator.language;

  var formatter = new Intl.NumberFormat(language, {
    style: "currency",
    currency: name,
    minimumFractionDigits: 0,
  });
  return formatter.format(x);
};

const roundToTwo = (num) => {
  return +(Math.round(num + "e+2") + "e-2");
};

const roundToThree = (num) => {
  return +(Math.round(num + "e+3") + "e-3");
};

export const roundToOne = (num) => {
  return +(Math.round(num + "e+1") + "e-1");
};
export const round = (v) => {
  return (v >= 0 || -1) * Math.round(Math.abs(v));
};

export const useLogout = () => {
  toLogout().then((res) => {
    document.cookie.split(";").forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    if (!window.location.href.includes("/login"))
      window.location.href = "/login";
  });
};

/**
 * Function returning the build date(as per provided epoch)
 * @param epoch Time in milliseconds
 */
export const getBuildDate = (epoch) => {
  const buildDate = moment(epoch).format("DD-MM-YYYY HH:MM");
  return buildDate;
};

export const customFilter = (input, elems, fields) => {
  if (input.length === 0) {
    return elems;
  }
  input = escapeRegExp(input);
  var words = input.split(" ");
  var regexs = [];
  for (var i = 0; i < words.length; i++) {
    var l__without = accentFold(words[i]);
    l__without = l__without.replace("è", "e");
    regexs.push(new RegExp(".*" + l__without + ".*", "i"));
  }
  var matchs = [];
  for (i = 0; i < elems.length; i++) {
    var toSearch = "";
    for (var j = 0; j < fields.length; j++) {
      if (elems[i][fields[j]]) {
        toSearch += elems[i][fields[j]];
      } else if (fields[j] == "lastMessage[0].message") {
        if (null != elems[i].lastMessage[0]) {
          toSearch += elems[i].lastMessage[0].message;
        }
      }
      if (j < fields.length - 1) {
        toSearch += " ";
      }
    }
    var match = true;
    for (var j = 0; j < regexs.length; j++) {
      var l__without = accentFold(toSearch);
      l__without = l__without.replace("è", "e");
      if (!regexs[j].exec(l__without)) {
        match = false;
      }
    }
    if (match) {
      matchs.push(elems[i]);
    }
  }
  return matchs;
};

const escapeRegExp = (str) => {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, " ");
};

export const accentFold = (inStr) => {
  return inStr.replace(
    /([ÀÄÂàáâãäå])|([Çç])|([ÉÈÊËèéêë])|([ÎÏìíîï])|([ñ])|([ÖÔòóôõöø])|([ß])|([ÜÛùúûü])|([Ÿÿ])|([æ])/g,
    function (str, a, c, e, i, n, o, s, u, y, ae) {
      if (a) return "a";
      if (c) return "c";
      if (e) return "e";
      if (i) return "i";
      if (n) return "n";
      if (o) return "o";
      if (s) return "s";
      if (u) return "u";
      if (y) return "y";
      if (ae) return "ae";
    },
  );
};
